// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* http://meyerweb.com/eric/tools/css/reset/ 
   v2.0 | 20110126
   License: none (public domain)
*/
.kore-chat-window-main-section * {
  box-sizing: border-box;
  font-family: var(--global-font-family);
  color: inherit;
  font-size: 100%;
}
.kore-chat-window-main-section applet, .kore-chat-window-main-section object, .kore-chat-window-main-section iframe,
.kore-chat-window-main-section h1, .kore-chat-window-main-section h2, .kore-chat-window-main-section h3, .kore-chat-window-main-section h4, .kore-chat-window-main-section h5, .kore-chat-window-main-section h6, .kore-chat-window-main-section p, .kore-chat-window-main-section blockquote, .kore-chat-window-main-section pre,
.kore-chat-window-main-section a, .kore-chat-window-main-section abbr, .kore-chat-window-main-section acronym, .kore-chat-window-main-section address, .kore-chat-window-main-section big, .kore-chat-window-main-section cite, .kore-chat-window-main-section code,
.kore-chat-window-main-section del, .kore-chat-window-main-section dfn, .kore-chat-window-main-section em, .kore-chat-window-main-section img, .kore-chat-window-main-section ins, .kore-chat-window-main-section kbd, .kore-chat-window-main-section q, .kore-chat-window-main-section s, .kore-chat-window-main-section samp,
.kore-chat-window-main-section small, .kore-chat-window-main-section strike, .kore-chat-window-main-section strong, .kore-chat-window-main-section sub, .kore-chat-window-main-section sup, .kore-chat-window-main-section tt, .kore-chat-window-main-section var,
.kore-chat-window-main-section b, .kore-chat-window-main-section u, .kore-chat-window-main-section i, .kore-chat-window-main-section center,
.kore-chat-window-main-section dl, .kore-chat-window-main-section dt, .kore-chat-window-main-section dd, .kore-chat-window-main-section ol, .kore-chat-window-main-section ul, .kore-chat-window-main-section li,
.kore-chat-window-main-section fieldset, .kore-chat-window-main-section form, .kore-chat-window-main-section label, .kore-chat-window-main-section legend, .kore-chat-window-main-section caption, .kore-chat-window-main-section tbody, .kore-chat-window-main-section tfoot, .kore-chat-window-main-section thead,
.kore-chat-window-main-section aside, .kore-chat-window-main-section canvas, .kore-chat-window-main-section details, .kore-chat-window-main-section embed,
.kore-chat-window-main-section figure, .kore-chat-window-main-section figcaption, .kore-chat-window-main-section footer, .kore-chat-window-main-section header, .kore-chat-window-main-section hgroup,
.kore-chat-window-main-section menu, .kore-chat-window-main-section nav, .kore-chat-window-main-section output, .kore-chat-window-main-section ruby, .kore-chat-window-main-section summary,
.kore-chat-window-main-section time, .kore-chat-window-main-section mark, .kore-chat-window-main-section audio, .kore-chat-window-main-section video {
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
}
.kore-chat-window-main-section h1, .kore-chat-window-main-section h2, .kore-chat-window-main-section h3, .kore-chat-window-main-section h4, .kore-chat-window-main-section h5, .kore-chat-window-main-section h6 {
  text-align: start;
}
.kore-chat-window-main-section {
  /* HTML5 display-role reset for older browsers */
}
.kore-chat-window-main-section body {
  line-height: normal;
}
.kore-chat-window-main-section ol, .kore-chat-window-main-section ul {
  list-style: none;
}
.kore-chat-window-main-section blockquote, .kore-chat-window-main-section q {
  quotes: none;
}
.kore-chat-window-main-section blockquote:before, .kore-chat-window-main-section blockquote:after,
.kore-chat-window-main-section q:before, .kore-chat-window-main-section q:after {
  content: "";
  content: none;
}
.kore-chat-window-main-section table {
  border-spacing: 0;
}
.kore-chat-window-main-section :focus-visible {
  outline-color: var(--sdk-global-theme-color);
  outline-offset: 1px;
  outline-style: auto;
}
.kore-chat-window-main-section img:focus {
  outline-color: var(--sdk-global-theme-color);
  outline-offset: 1px;
  outline-style: auto;
  outline: 1px solid var(--sdk-global-theme-color);
}
.kore-chat-window-main-section button {
  cursor: pointer;
}
.kore-chat-window-main-section {
  /********* Scroll bar global css start *********************/
}
.kore-chat-window-main-section body::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  cursor: pointer;
}
.kore-chat-window-main-section ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  cursor: pointer;
}
.kore-chat-window-main-section ::-webkit-scrollbar-thumb {
  background-color: var(--sdk-scrollbar-bg);
  border-radius: 7px;
  transition: background-color 0.2s linear, width 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;
}
.kore-chat-window-main-section input::-webkit-outer-spin-button,
.kore-chat-window-main-section input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.kore-chat-window-main-section {
  /* Firefox */
}
.kore-chat-window-main-section input[type=number] {
  -moz-appearance: textfield;
}
.kore-chat-window-main-section {
  /********* Scroll bar global css end *********************/
}

.display-hide {
  display: none !important;
}

@keyframes remove-hidden {
  0% {
    overflow: hidden;
  }
  100% {
    overflow: inherit;
  }
}
@keyframes bounce2 {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-30px);
  }
  60% {
    transform: translateY(-15px);
  }
}
@keyframes bounce-in-avatar {
  0% {
    opacity: 0;
    transform: scale(0.3);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  70% {
    transform: translateY(20px);
  }
  100% {
    transform: scale(1) translate(0);
  }
}
@keyframes avatarBubbleAnim {
  0% {
    opacity: 0;
    transform: translateY(10px); /* Move the elements 100% down */
  }
  80% {
    opacity: 1;
    transform: translateY(-10px); /* Move the elements to their original position */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes slide-up {
  0% {
    opacity: 0;
    transform: translateY(100%); /* Move the elements 100% down */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes quick {
  0% {
    opacity: 0;
    transform: scale(0);
    overflow: hidden;
  }
  90%, 50% {
    overflow: hidden;
  }
  100% {
    opacity: 1;
    transform: scale(1);
    overflow: inherit;
  }
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    overflow: hidden;
  }
  40% {
    opacity: 1;
    overflow: hidden;
  }
  60% {
    transform: translate(-10px);
  }
  80% {
    transform: translate(-15px);
  }
  100% {
    transform: none;
    overflow: inherit;
  }
}
@keyframes bubbleAnim {
  0% {
    opacity: 0;
    transform: translateY(10%);
  }
  20% {
    opacity: 0;
    transform: translateY(10%);
  }
  100% {
    opacity: 1;
    transform: translate(0%);
  }
}
@keyframes voiceShowAnim {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  100% {
    opacity: 1;
    transform: translate(0%);
  }
}
@keyframes left-to-right-slide-anim {
  0% {
    opacity: 0;
    transform: translateX(-100%);
  }
  80% {
    opacity: 0.5;
    transform: translateX(0px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
@keyframes right-to-left-slide-anim {
  0% {
    opacity: 0;
    transform: translateX(100%); /* Move the elements 100% down */
  }
  80% {
    opacity: 0.5;
    transform: translateX(10px); /* Move the elements to their original position */
  }
  100% {
    opacity: 1;
    transform: translate(0); /* Move the elements to their original position */
  }
}
@keyframes recording {
  from {
    transform: scale(1.1);
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 1px rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 5px rgba(75, 78, 222, 0.2);
  }
  50% {
    transform: none;
  }
  to {
    transform: scale(1.1);
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 6px rgba(75, 78, 222, 0), 0 0 0 10px rgba(75, 78, 222, 0);
  }
}
@keyframes voiceAnim {
  from {
    transform: scale(1.1);
  }
  0% {
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 1px rgba(75, 78, 222, 0.2), 0 0 0 3px rgba(75, 78, 222, 0.2), 0 0 0 5px rgba(75, 78, 222, 0.2);
  }
  50% {
    transform: none;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(75, 78, 222, 0.2), 0 0 0 4px rgba(75, 78, 222, 0.2), 0 0 0 20px rgba(75, 78, 222, 0), 0 0 0 30px rgba(75, 78, 222, 0);
    transform: scale(1.1);
  }
  to {
    transform: scale(1.1);
  }
}
@keyframes closeBottomToTopAnim {
  0% {
    transform: translateY(0%);
  }
  100% {
    opacity: 0;
    transform: translateY(100%);
    display: none;
  }
}
@keyframes slideBottomToTopAnim {
  0% {
    opacity: 0;
    transform: translateY(100%);
  }
  80% {
    opacity: 1;
    transform: translateY(-10px);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.slideInRight {
  -webkit-animation-name: slideInRight;
  animation-name: slideInRight;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  80% {
    -webkit-transform: translateX(0);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
@keyframes slideInRight {
  0% {
    -webkit-transform: translateX(100%);
    transform: translateX(100%);
    visibility: visible;
  }
  80% {
    -webkit-transform: translateX(0);
    transform: translateX(2px);
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
  }
}
.scale-up-br {
  -webkit-animation: scale-up-br 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: scale-up-br 0.4s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.scale-out-br {
  -webkit-animation: scale-out-br 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  animation: scale-out-br 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@-webkit-keyframes scale-out-br {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@keyframes scale-out-br {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(0);
    transform: scale(0);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
    opacity: 1;
  }
}
@-webkit-keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@keyframes scale-up-br {
  0% {
    -webkit-transform: scale(0.5);
    transform: scale(0.5);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transform-origin: 100% 100%;
    transform-origin: 100% 100%;
  }
}
@-webkit-keyframes spinLoader {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spinLoader {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.rotateIn {
  -webkit-animation-name: rotateIn;
  animation-name: rotateIn;
  -webkit-animation-duration: 0.5s;
  animation-duration: 0.5s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}
@keyframes rotateIn {
  0% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: rotate3d(0, 0, 1, -200deg);
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }
  100% {
    -webkit-transform-origin: center;
    transform-origin: center;
    -webkit-transform: none;
    transform: none;
    opacity: 1;
  }
}
@keyframes dot-flashing {
  0% {
    background-color: var(--sdk-gloabl-bg-secondary);
  }
  50%, 100% {
    opacity: 0.5;
  }
}
.fadeIn {
  -webkit-animation-name: fadeIn;
  animation-name: fadeIn;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  display: flex;
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.bounceInUp {
  -webkit-animation-name: bounceInUp;
  animation-name: bounceInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
@keyframes bounceInUp {
  0%, 60%, 75%, 90%, 100% {
    -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 3000px, 0);
    transform: translate3d(0, 3000px, 0);
  }
  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, -20px, 0);
    transform: translate3d(0, -20px, 0);
  }
  75% {
    -webkit-transform: translate3d(0, 10px, 0);
    transform: translate3d(0, 10px, 0);
  }
  90% {
    -webkit-transform: translate3d(0, -5px, 0);
    transform: translate3d(0, -5px, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeInUp {
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInUp {
  0% {
    opacity: 1;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, 100%, 0);
    transform: translate3d(0, 100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
.fadeOut {
  -webkit-animation-name: fadeOut;
  animation-name: fadeOut;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.slideOutDown {
  -webkit-animation-name: slideOutDown;
  animation-name: slideOutDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes slideOutDown {
  0% {
    -webkit-transform: translateY(-10%);
    transform: translateY(-10%);
  }
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
}
:root {
  --sdk-gloabl-primary-color:var(--chat-sdk-branding--global-primary-color);
  --sdk-gloabl-secondary-color:var(--chat-sdk-branding--global-secondary-color);
  --sdk-global-primary-text:var(--chat-sdk-branding--global-primary-text);
  --sdk-global-secondary-text:var(--chat-sdk-branding--global-secondary-text);
  --theme-panel-wigdet-primary-bg-color:var(--sdk-gloabl-primary-color);
  --theme-panel-wigdet-secondary-bg-color:var(--sdk-gloabl-secondary-color);
  --theme-panel-wigdet-primary-text-color:var(--sdk-global-primary-text);
  --theme-panel-wigdet-secondary-text-color:var(--sdk-global-secondary-text) ;
  --panel-wigdet-primary-bg-color:var(--theme-panel-wigdet-primary-bg-color);
  --panel-wigdet-secondary-bg-color:var(--theme-panel-wigdet-secondary-bg-color);
  --panel-wigdet-primary-text-color:var(--theme-panel-wigdet-primary-text-color);
  --panel-wigdet-secondary-text-color:var(--theme-panel-wigdet-secondary-text-color);
  --panel-wigdet-border-color:var(--panel-wigdet-secondary-bg-color);
  --panel-wigdet-white-bg-color:var(--chat-sdk-branding--widget_panel-colors-bg_color);
  --panel-wigdet-white-text-color:#fff;
  --panel-wigdet-left-menu-bg:var(--chat-sdk-branding--widget_panel-colors-bg_color);
  --panel-wigdet-left-menu-selected-bg:var(--chat-sdk-branding--widget_panel-colors-sel_bg_color);
  --panel-wigdet-left-menu-font-clr:var(--chat-sdk-branding--widget_panel-colors-color);
  --panel-wigdet-left-menu-selected-font-clr:var(--chat-sdk-branding--widget_panel-colors-sel_color);
  --global-font-family: var(--chat-sdk-branding--global-font-family);
  --sdk-global-theme-color:var(--sdk-gloabl-primary-color);
  --sdk-gloabl-bg-secondary:var(--sdk-gloabl-secondary-color);
  --sdk-global-white:var(--sdk-global-secondary-text);
  --sdk-global-white-bg:var(--chat-sdk-branding--body-white-background);
  --sdk-gloabl-text-color:var(--sdk-global-primary-text);
  --sdk-gloabl-text-desc-color:var(--sdk-global-primary-text);
  --sdk-gloabl-border-color:var(--sdk-gloabl-secondary-color);
  --sdk-scrollbar-bg:var(--sdk-gloabl-bg-secondary);
  --avatar-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);
  --avatar-send-msg-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);
  --avatar-icon-color:var(--chat-sdk-branding--chat_bubble-bg-secondary_color);
  --avatar-text-colr:var(--sdk-gloabl-text-color);
  --chat-widget-box-shadow:0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  --agent-joined-bg:var(--sdk-gloabl-bg-secondary);
  --agent-joined-border:var(--sdk-gloabl-border-color);
  --agent-joined-text-color:var(--sdk-gloabl-text-color);
  --welcome-bg:var(--sdk-global-white-bg);
  --welcome-shadow:0px 4px 12px 2px rgba(32,33,36,0.12);
  --welcome-header-bg: var(--chat-sdk-branding--welcome_screen-background-color);
  --welcome-header-text-color:var(--chat-sdk-branding--welcome_screen-top_fonts-color);
  --welcome-start-conv-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-bot-bg:var(--sdk-global-theme-color);
  --welcome-start-conv-bot-title:var(--sdk-gloabl-text-color);
  --welcome-start-conv-bot-desc:var(--sdk-gloabl-text-desc-color);
  --welcome-start-conv-quick-btn-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-quick-btn-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-quick-btn-text:var(--sdk-gloabl-text-color);
  --welcome-start-conv-search-bg:var(--sdk-global-white-bg);
  --welcome-start-conv-search-border:var(--sdk-gloabl-border-color);
  --welcome-start-conv-button-bg:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_button_color);
  --welcome-start-conv-button-border:var(--sdk-global-theme-color);
  --welcome-start-conv-button-color:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_text_color);
  --welcome-footer-bg:var(--chat-sdk-branding--welcome_screen-bottom_background-color);
  --welecome-footer-text-color:var(--sdk-gloabl-text-color);
  --chat-widget-header-bg:var(--chat-sdk-branding--header-bg-bg_color);
  --chat-widget-header-border:var(--sdk-gloabl-border-color);
  --chat-widget-header-bg-large:linear-gradient(180deg, var(--sdk-global-theme-color) 0%, var(--sdk-global-theme-color) 40.67%, rgba(255, 255, 255, 0) 80.38%);
  --chat-widget-header-bg-large-info-bg:var(--sdk-global-white-bg);
  --chat-widget-header-bg-large-actions-color:var(--sdk-global-white);
  --chat-widget-header-bot-name-color:var(--chat-sdk-branding--header-title-color);
  --chat-widget-header-bot-name-desc:var(--chat-sdk-branding--header-sub_title-color);
  --chat-widget-header-actions-color:var(--chat-sdk-branding--header-icons-color);
  --chat-widget-header-img-border:var(--sdk-global-white);
  --chat-widget-body-bg:var(--chat-sdk-branding--body-background-bg);
  --chat-widget-footer-bg: var(--sdk-global-white-bg);
  --chat-widget-compose-bar-bg:var(--chat-sdk-branding--footer-bg-bg_color);
  --chat-widget-compose-bar-border:var(--sdk-gloabl-border-color);
  --chat-widget-compose-bar-text-area-bg:var(--chat-sdk-branding--footer-compose_bar-bg_color);
  --chat-widget-compose-bar-text-area-border:var(--chat-sdk-branding--footer-compose_bar-outline-color);
  --chat-widget-compose-bar-text-area-color:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-text-area-placeholder-color:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-voice-speak-info-text:var(--sdk-gloabl-text-color);
  --chat-widget-compose-bar-voice-icon-bg:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-icon-border:var(--sdk-global-white-bg);
  --chat-widget-compose-bar-voice-icon-color:var(--sdk-global-white);
  --chat-widget-compose-bar-voice-speak-msg-bg:var(--sdk-global-white-bg);
  --chat-widget-compose-bar-voice-speak-msg-selected-bg:var(--sdk-gloabl-bg-secondary);
  --chat-widget-compose-bar-voice-speak-msg-color:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-speak-msg-border:var(--sdk-global-theme-color);
  --chat-widget-compose-bar-voice-recording-animation-shadow:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 1px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 5px rgba(var(--sdk-global-theme-color), 0.2);
  --chat-widget-compose-bar-voice-recording-animation-shadow-zoom:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2),0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2),0 0 0 6px rgba(var(--sdk-global-theme-color), 0),0 0 0 10px rgba(var(--sdk-global-theme-color), 0);
  --chat-widget-compose-bar-menu-icon-color:var(--chat-sdk-branding--footer-menu_icon-color);
  --chat-widget-compose-bar-other-icons:var(--chat-sdk-branding--footer-icons-color);
  --bot-bubble-text-color:var(--sdk-gloabl-text-color);
  --bot-bubble-msg-bg:var(--chat-sdk-branding--body-bot_message-bg_color);
  --bot-bubble-msg-bg-hover:var(--chat-sdk-branding--body-bot_message-bg_color);
  --bot-bubble-msg-color:var(--chat-sdk-branding--body-bot_message-color);
  --bot-bubble-img-border:var(--sdk-global-white-bg);
  --name-color:var(--chat-sdk-branding--body-agent_message-title_color);
  --time-stamp-color:var(--chat-sdk-branding--body-time_stamp-color);
  --agent-bubble-text-color:var(--sdk-gloabl-text-color);
  --agent-bubble-msg-bg:var(--chat-sdk-branding--body-user_message-bg_color);
  --agent-bubble-msg-bg-hover:var(--chat-sdk-branding--body-user_message-bg_color);
  --agent-bubble-msg-color:var(--chat-sdk-branding--body-user_message-color);
  --agent-bubble-img-border:var(--sdk-global-white-bg);
  --agent-bubble-read-status-icon-color:#22C55E;
  --date-seperator-bg:var(--sdk-gloabl-bg-secondary);
  --date-seperator-border:var(--sdk-gloabl-border-color);
  --date-seperator-line-border:var(--sdk-gloabl-border-color);
  --date-seperator-color:var(--sdk-gloabl-text-color);
  --button-bg-color: var(--chat-sdk-branding--body-buttons-bg_color);
  --button-text-color: var(--chat-sdk-branding--body-buttons-color);
  --button-temp-bg:var(--sdk-global-white-bg);
  --button-temp-border:var(--sdk-gloabl-border-color);
  --button-temp-color:var(--sdk-gloabl-text-color);
  --button-temp-bg-hover:var(--sdk-gloabl-bg-secondary);
  --button-temp-bg-variation-1:var(--sdk-gloabl-bg-secondary);
  --button-temp-variation-1-border:transparent;
  --button-temp-variation-1-color:var(--button-bg-color);
  --button-temp-bg-variation-1-hover:linear-gradient(0deg, rgba(75, 78, 222, 0.07) 0%, rgba(75, 78, 222, 0.07) 100%), var(--sdk-gloabl-bg-secondary);
  --button-temp-bg-variation-2:var(--button-bg-color);
  --button-temp-variation-2-border:var(--button-bg-color);
  --button-temp-variation-2-color:var(--button-text-color);
  --button-temp-bg-variation-2-hover:linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), var(--button-bg-color);
  --card-main-wrapper-bg:var(--sdk-gloabl-bg-secondary);
  --card-main-wrapper-border:var(--sdk-gloabl-border-color);
  --card-heading-title:var(--sdk-gloabl-text-color);
  --card-temp-border:var(--sdk-gloabl-border-color);
  --card-temp-bg:var(--sdk-global-white-bg);
  --card-temp-color:var(--sdk-gloabl-text-color);
  --card-temp-h1-color:var(--sdk-gloabl-text-color);
  --card-temp-p-color:var(--sdk-gloabl-text-color);
  --card-temp-view-more-bg:var(--sdk-global-white-bg);
  --card-temp-view-more-color:var(--sdk-global-theme-color);
  --card-temp-view-more-border:var(--sdk-global-theme-color);
  --card-temp-border-divided-bg:var(--sdk-gloabl-border-color);
  --form-temp-bg:var(--sdk-gloabl-bg-secondary);
  --form-temp--text-color:var(--sdk-gloabl-text-color);
  --form-temp-input-bg:var(--sdk-global-white-bg);
  --form-temp-input-box-shadow:0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  --form-temp-input-placeholder:var(--sdk-gloabl-text-color);
  --table-border:var(--sdk-gloabl-border-color);
  --table-header-text-color:var(--sdk-gloabl-text-color);
  --table-body-tr-bg:var(--sdk-gloabl-bg-secondary);
  --table-desc-text-color:var(--sdk-gloabl-text-color);
  --radio-desc-text-clr:var(--sdk-gloabl-text-color);
  --radio-border:var(--sdk-gloabl-border-color);
  --radio-bg:var(--sdk-global-white-bg);
  --radio-checked-shadow:inset 0 0 0 6px var(--sdk-global-white-bg);
}

.kr-button-primary {
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  width: 100%;
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  background: var(--button-temp-bg-variation-2);
  border: 1px solid var(--button-temp-variation-2-border);
  color: var(--button-temp-variation-2-color);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-primary.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-primary:hover {
  background: var(--button-temp-bg-variation-2-hover);
}
.kr-button-primary:disabled {
  opacity: 0.5;
  pointer-events: none;
}

.kr-button-secondary {
  width: 100%;
  background: var(--button-temp-bg);
  border: 1px solid var(--button-temp-border);
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  color: var(--button-temp-color);
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-secondary.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-secondary:hover {
  background: var(--button-temp-bg-hover);
}

.kr-button-blue-light {
  width: 100%;
  background: var(--button-bg-color);
  border: 1px solid var(--button-bg-color);
  border-radius: 4px;
  padding: 5px 16px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  height: 30px;
  color: var(--button-text-color);
  cursor: pointer;
  text-align: center;
  transition: 0.2s all ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
}
.kr-button-blue-light svg path {
  fill: var(--button-bg-color);
}
.kr-button-blue-light.lg {
  padding: 10px 16px;
  height: 40px;
  font-size: 14px;
}
.kr-button-blue-light:hover {
  background: var(--button-bg-color);
}

.kore-chat-window-main-section .chart-disp-val {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section .chart-axis-line {
  stroke: var(--sdk-gloabl-text-color);
}
.kore-chat-window-main-section .legend-title {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section polyline {
  stroke: var(--sdk-gloabl-text-color);
}
.kore-chat-window-main-section .mouse-per-line text {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}
.kore-chat-window-main-section .legend-value {
  fill: var(--sdk-gloabl-text-color);
  font-size: 12px;
}

.kwsdk-text-xl {
  font-size: 20px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 30px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-xl.medium {
  font-weight: 500;
}
.kwsdk-text-xl.semibold {
  font-weight: 600;
}
.kwsdk-text-xl.bold {
  font-weight: 700;
}

.kwsdk-text-lg {
  font-size: 18px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 28px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-lg.medium {
  font-weight: 500;
}
.kwsdk-text-lg.semibold {
  font-weight: 600;
}
.kwsdk-text-lg.bold {
  font-weight: 700;
}

.kwsdk-text-md {
  font-size: 16px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 24px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-md.medium {
  font-weight: 500;
}
.kwsdk-text-md.semibold {
  font-weight: 600;
}
.kwsdk-text-md.bold {
  font-weight: 700;
}

.kwsdk-text-sm {
  font-size: 14px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 20px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-sm.medium {
  font-weight: 500;
}
.kwsdk-text-sm.semibold {
  font-weight: 600;
}
.kwsdk-text-sm.bold {
  font-weight: 700;
}

.kwsdk-text-xs {
  font-size: 12px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 16px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-xs.medium {
  font-weight: 500;
}
.kwsdk-text-xs.semibold {
  font-weight: 600;
}
.kwsdk-text-xs.bold {
  font-weight: 700;
}

.kwsdk-text-xxs {
  font-size: 10px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 12px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-xxs.medium {
  font-weight: 500;
}
.kwsdk-text-xxs.semibold {
  font-weight: 600;
}
.kwsdk-text-xxs.bold {
  font-weight: 700;
}

.kwsdk-text-xxxs {
  font-size: 8px;
  font-weight: var(--font-weight-normal-Regular, 400);
  line-height: 12px;
  color: var(--sdk-gloabl-text-color);
  text-align: start;
  margin: 0;
}
.kwsdk-text-xxxs.medium {
  font-weight: 500;
}
.kwsdk-text-xxxs.semibold {
  font-weight: 600;
}
.kwsdk-text-xxxs.bold {
  font-weight: 700;
}

.kwsdk-d-none {
  display: none !important;
}

.kwsdk-d-inline {
  display: inline !important;
}

.kwsdk-d-inline-block {
  display: inline-block !important;
}

.kwsdk-d-block {
  display: block !important;
}

.kwsdk-d-flex {
  display: flex !important;
}

.kwsdk-d-inline-flex {
  display: inline-flex !important;
}

.kwsdk-d-grid {
  display: grid !important;
}

.kwsdk-d-inline-grid {
  display: inline-grid !important;
}

.kwsdk-d-table {
  display: table !important;
}

.kwsdk-d-table-row {
  display: table-row !important;
}

.kwsdk-d-table-cell {
  display: table-cell !important;
}

.kwsdk-flex-row {
  flex-direction: row;
}

.kwsdk-flex-column {
  flex-direction: column;
}

.kwsdk-flex-row-reverse {
  flex-direction: row-reverse;
}

.kwsdk-flex-column-reverse {
  flex-direction: column-reverse;
}

.kwsdk-justify-content-start {
  justify-content: flex-start;
}

.kwsdk-justify-content-end {
  justify-content: flex-end;
}

.kwsdk-justify-content-center {
  justify-content: center;
}

.kwsdk-justify-content-between {
  justify-content: space-between;
}

.kwsdk-justify-content-around {
  justify-content: space-around;
}

.kwsdk-justify-content-evenly {
  justify-content: space-evenly;
}

.kwsdk-align-items-start {
  align-items: flex-start;
}

.kwsdk-align-items-end {
  align-items: flex-end;
}

.kwsdk-align-items-center {
  align-items: center;
}

.kwsdk-align-items-baseline {
  align-items: baseline;
}

.kwsdk-align-items-stretch {
  align-items: stretch;
}

.kwsdk-align-content-start {
  align-content: flex-start;
}

.kwsdk-align-content-end {
  align-content: flex-end;
}

.kwsdk-align-content-center {
  align-content: center;
}

.kwsdk-align-content-between {
  align-content: space-between;
}

.kwsdk-align-content-around {
  align-content: space-around;
}

.kwsdk-align-content-stretch {
  align-content: stretch;
}

.kwsdk-align-self-auto {
  align-self: auto;
}

.kwsdk-align-self-start {
  align-self: flex-start;
}

.kwsdk-align-self-end {
  align-self: flex-end;
}

.kwsdk-align-self-center {
  align-self: center;
}

.kwsdk-align-self-baseline {
  align-self: baseline;
}

.kwsdk-align-self-stretch {
  align-self: stretch;
}

.kwsdk-flex-wrap {
  flex-wrap: wrap;
}

.kwsdk-flex-nowrap {
  flex-wrap: nowrap;
}

.kwsdk-flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}

.kwsdk-flex-fill {
  flex: 1 1 auto;
}

.kwsdk-flex-grow-0 {
  flex-grow: 0;
}

.kwsdk-flex-grow-1 {
  flex-grow: 1;
}

.kwsdk-flex-shrink-0 {
  flex-shrink: 0;
}

.kwsdk-flex-shrink-1 {
  flex-shrink: 1;
}

.kwsdk-order-0 {
  order: 0;
}

.kwsdk-order-1 {
  order: 1;
}

.kwsdk-order-2 {
  order: 2;
}

.kwsdk-order-3 {
  order: 3;
}

.kwsdk-order-4 {
  order: 4;
}

.kwsdk-order-5 {
  order: 5;
}

.kwsdk-order-first {
  order: -1;
}

.kwsdk-order-last {
  order: 6;
}

.kwsdk-gap-0 {
  gap: 0;
}

.kwsdk-row-gap-0 {
  row-gap: 0;
}

.kwsdk-column-gap-0 {
  column-gap: 0;
}

.kwsdk-gap-1 {
  gap: 0.25rem;
}

.kwsdk-row-gap-1 {
  row-gap: 0.25rem;
}

.kwsdk-column-gap-1 {
  column-gap: 0.25rem;
}

.kwsdk-gap-2 {
  gap: 0.5rem;
}

.kwsdk-row-gap-2 {
  row-gap: 0.5rem;
}

.kwsdk-column-gap-2 {
  column-gap: 0.5rem;
}

.kwsdk-gap-3 {
  gap: 0.75rem;
}

.kwsdk-row-gap-3 {
  row-gap: 0.75rem;
}

.kwsdk-column-gap-3 {
  column-gap: 0.75rem;
}

.kwsdk-gap-4 {
  gap: 1rem;
}

.kwsdk-row-gap-4 {
  row-gap: 1rem;
}

.kwsdk-column-gap-4 {
  column-gap: 1rem;
}

.kwsdk-gap-5 {
  gap: 1.25rem;
}

.kwsdk-row-gap-5 {
  row-gap: 1.25rem;
}

.kwsdk-column-gap-5 {
  column-gap: 1.25rem;
}

.kwsdk-gap-6 {
  gap: 1.5rem;
}

.kwsdk-row-gap-6 {
  row-gap: 1.5rem;
}

.kwsdk-column-gap-6 {
  column-gap: 1.5rem;
}

.kwsdk-m-0 {
  margin: 0 !important;
}

.kwsdk-m-1 {
  margin: 0.25rem !important;
}

.kwsdk-m-2 {
  margin: 0.5rem !important;
}

.kwsdk-m-3 {
  margin: 0.75rem !important;
}

.kwsdk-m-4 {
  margin: 1rem !important;
}

.kwsdk-m-5 {
  margin: 1.25rem !important;
}

.kwsdk-m-6 {
  margin: 1.5rem !important;
}

.kwsdk-m-auto {
  margin: auto !important;
}

.kwsdk-mt-0 {
  margin-top: 0 !important;
}

.kwsdk-mt-1 {
  margin-top: 0.25rem !important;
}

.kwsdk-mt-2 {
  margin-top: 0.5rem !important;
}

.kwsdk-mt-3 {
  margin-top: 0.75rem !important;
}

.kwsdk-mt-4 {
  margin-top: 1rem !important;
}

.kwsdk-mt-5 {
  margin-top: 1.25rem !important;
}

.kwsdk-mt-6 {
  margin-top: 1.5rem !important;
}

.kwsdk-mt-auto {
  margin-top: auto !important;
}

.kwsdk-mb-0 {
  margin-bottom: 0 !important;
}

.kwsdk-mb-1 {
  margin-bottom: 0.25rem !important;
}

.kwsdk-mb-2 {
  margin-bottom: 0.5rem !important;
}

.kwsdk-mb-3 {
  margin-bottom: 0.75rem !important;
}

.kwsdk-mb-4 {
  margin-bottom: 1rem !important;
}

.kwsdk-mb-5 {
  margin-bottom: 1.25rem !important;
}

.kwsdk-mb-6 {
  margin-bottom: 1.5rem !important;
}

.kwsdk-mb-auto {
  margin-bottom: auto !important;
}

.kwsdk-ms-0 {
  margin-inline-start: 0 !important;
}

.kwsdk-ms-1 {
  margin-inline-start: 0.25rem !important;
}

.kwsdk-ms-2 {
  margin-inline-start: 0.5rem !important;
}

.kwsdk-ms-3 {
  margin-inline-start: 0.75rem !important;
}

.kwsdk-ms-4 {
  margin-inline-start: 1rem !important;
}

.kwsdk-ms-5 {
  margin-inline-start: 1.25rem !important;
}

.kwsdk-ms-6 {
  margin-inline-start: 1.5rem !important;
}

.kwsdk-ms-auto {
  margin-inline-start: auto !important;
}

.kwsdk-me-0 {
  margin-inline-end: 0 !important;
}

.kwsdk-me-1 {
  margin-inline-end: 0.25rem !important;
}

.kwsdk-me-2 {
  margin-inline-end: 0.5rem !important;
}

.kwsdk-me-3 {
  margin-inline-end: 0.75rem !important;
}

.kwsdk-me-4 {
  margin-inline-end: 1rem !important;
}

.kwsdk-me-5 {
  margin-inline-end: 1.25rem !important;
}

.kwsdk-me-6 {
  margin-inline-end: 1.5rem !important;
}

.kwsdk-me-auto {
  margin-inline-end: auto !important;
}

.kwsdk-p-0 {
  padding: 0 !important;
}

.kwsdk-p-1 {
  padding: 0.25rem !important;
}

.kwsdk-p-2 {
  padding: 0.5rem !important;
}

.kwsdk-p-3 {
  padding: 0.75rem !important;
}

.kwsdk-p-4 {
  padding: 1rem !important;
}

.kwsdk-p-5 {
  padding: 1.25rem !important;
}

.kwsdk-p-6 {
  padding: 1.5rem !important;
}

.kwsdk-pt-0 {
  padding-top: 0 !important;
}

.kwsdk-pt-1 {
  padding-top: 0.25rem !important;
}

.kwsdk-pt-2 {
  padding-top: 0.5rem !important;
}

.kwsdk-pt-3 {
  padding-top: 0.75rem !important;
}

.kwsdk-pt-4 {
  padding-top: 1rem !important;
}

.kwsdk-pt-5 {
  padding-top: 1.25rem !important;
}

.kwsdk-pt-6 {
  padding-top: 1.5rem !important;
}

.kwsdk-pb-0 {
  padding-bottom: 0 !important;
}

.kwsdk-pb-1 {
  padding-bottom: 0.25rem !important;
}

.kwsdk-pb-2 {
  padding-bottom: 0.5rem !important;
}

.kwsdk-pb-3 {
  padding-bottom: 0.75rem !important;
}

.kwsdk-pb-4 {
  padding-bottom: 1rem !important;
}

.kwsdk-pb-5 {
  padding-bottom: 1.25rem !important;
}

.kwsdk-pb-6 {
  padding-bottom: 1.5rem !important;
}

.kwsdk-ps-0 {
  padding-inline-start: 0 !important;
}

.kwsdk-ps-1 {
  padding-inline-start: 0.25rem !important;
}

.kwsdk-ps-2 {
  padding-inline-start: 0.5rem !important;
}

.kwsdk-ps-3 {
  padding-inline-start: 0.75rem !important;
}

.kwsdk-ps-4 {
  padding-inline-start: 1rem !important;
}

.kwsdk-ps-5 {
  padding-inline-start: 1.25rem !important;
}

.kwsdk-ps-6 {
  padding-inline-start: 1.5rem !important;
}

.kwsdk-pe-0 {
  padding-inline-end: 0 !important;
}

.kwsdk-pe-1 {
  padding-inline-end: 0.25rem !important;
}

.kwsdk-pe-2 {
  padding-inline-end: 0.5rem !important;
}

.kwsdk-pe-3 {
  padding-inline-end: 0.75rem !important;
}

.kwsdk-pe-4 {
  padding-inline-end: 1rem !important;
}

.kwsdk-pe-5 {
  padding-inline-end: 1.25rem !important;
}

.kwsdk-pe-6 {
  padding-inline-end: 1.5rem !important;
}

.kwsdk-px-0 {
  padding-inline-start: 0 !important;
  padding-inline-end: 0 !important;
}

.kwsdk-py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.kwsdk-mx-0 {
  margin-inline-start: 0 !important;
  margin-inline-end: 0 !important;
}

.kwsdk-my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.kwsdk-px-1 {
  padding-inline-start: 0.25rem !important;
  padding-inline-end: 0.25rem !important;
}

.kwsdk-py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.kwsdk-mx-1 {
  margin-inline-start: 0.25rem !important;
  margin-inline-end: 0.25rem !important;
}

.kwsdk-my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.kwsdk-px-2 {
  padding-inline-start: 0.5rem !important;
  padding-inline-end: 0.5rem !important;
}

.kwsdk-py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.kwsdk-mx-2 {
  margin-inline-start: 0.5rem !important;
  margin-inline-end: 0.5rem !important;
}

.kwsdk-my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.kwsdk-px-3 {
  padding-inline-start: 0.75rem !important;
  padding-inline-end: 0.75rem !important;
}

.kwsdk-py-3 {
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.kwsdk-mx-3 {
  margin-inline-start: 0.75rem !important;
  margin-inline-end: 0.75rem !important;
}

.kwsdk-my-3 {
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.kwsdk-px-4 {
  padding-inline-start: 1rem !important;
  padding-inline-end: 1rem !important;
}

.kwsdk-py-4 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.kwsdk-mx-4 {
  margin-inline-start: 1rem !important;
  margin-inline-end: 1rem !important;
}

.kwsdk-my-4 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.kwsdk-px-5 {
  padding-inline-start: 1.25rem !important;
  padding-inline-end: 1.25rem !important;
}

.kwsdk-py-5 {
  padding-top: 1.25rem !important;
  padding-bottom: 1.25rem !important;
}

.kwsdk-mx-5 {
  margin-inline-start: 1.25rem !important;
  margin-inline-end: 1.25rem !important;
}

.kwsdk-my-5 {
  margin-top: 1.25rem !important;
  margin-bottom: 1.25rem !important;
}

.kwsdk-px-6 {
  padding-inline-start: 1.5rem !important;
  padding-inline-end: 1.5rem !important;
}

.kwsdk-py-6 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.kwsdk-mx-6 {
  margin-inline-start: 1.5rem !important;
  margin-inline-end: 1.5rem !important;
}

.kwsdk-my-6 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.kwsdk-mx-auto {
  margin-inline-start: auto !important;
  margin-inline-end: auto !important;
}

.kwsdk-my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.kwsdk-text-start {
  text-align: start !important;
}

.kwsdk-text-end {
  text-align: end !important;
}

.kwsdk-text-center {
  text-align: center !important;
}

.kwsdk-text-lowercase {
  text-transform: lowercase !important;
}

.kwsdk-text-uppercase {
  text-transform: uppercase !important;
}

.kwsdk-text-capitalize {
  text-transform: capitalize !important;
}

.kwsdk-fw-bold {
  font-weight: 700 !important;
}

.kwsdk-fw-semibold {
  font-weight: 600 !important;
}

.kwsdk-fw-normal {
  font-weight: 400 !important;
}

.kwsdk-fw-medium {
  font-weight: 500 !important;
}

.kwsdk-fw-light {
  font-weight: 300 !important;
}

.kwsdk-fst-italic {
  font-style: italic !important;
}

.kwsdk-fst-normal {
  font-style: normal !important;
}

.kwsdk-text-wrap {
  white-space: normal !important;
}

.kwsdk-text-nowrap {
  white-space: nowrap !important;
}

.kwsdk-text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap !important;
}

.kwsdk-line-clamp-1 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 1;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.kwsdk-line-clamp-2 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  overflow: hidden;
}

.kwsdk-line-clamp-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.kwsdk-line-clamp-4 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 4;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

.kwsdk-line-clamp-5 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  line-clamp: 5;
  -webkit-line-clamp: 5;
  overflow: hidden;
}

.kwsdk-text-decoration-none {
  text-decoration: none !important;
}

.kwsdk-text-decoration-underline {
  text-decoration: underline !important;
}

.kwsdk-text-decoration-line-through {
  text-decoration: line-through !important;
}

.kwsdk-overflow-auto {
  overflow: auto !important;
}

.kwsdk-overflow-x-auto {
  overflow-x: auto !important;
}

.kwsdk-overflow-y-auto {
  overflow-y: auto !important;
}

.kwsdk-overflow-hidden {
  overflow: hidden !important;
}

.kwsdk-overflow-x-hidden {
  overflow-x: hidden !important;
}

.kwsdk-overflow-y-hidden {
  overflow-y: hidden !important;
}

.kwsdk-overflow-visible {
  overflow: visible !important;
}

.kwsdk-overflow-x-visible {
  overflow-x: visible !important;
}

.kwsdk-overflow-y-visible {
  overflow-y: visible !important;
}

.kwsdk-overflow-scroll {
  overflow: scroll !important;
}

.kwsdk-overflow-x-scroll {
  overflow-x: scroll !important;
}

.kwsdk-overflow-y-scroll {
  overflow-y: scroll !important;
}

.kwsdk-position-static {
  position: static !important;
}

.kwsdk-position-relative {
  position: relative !important;
}

.kwsdk-position-absolute {
  position: absolute !important;
}

.kwsdk-position-fixed {
  position: fixed !important;
}

.kwsdk-position-sticky {
  position: sticky !important;
}

.kwsdk-top-0 {
  top: 0 !important;
}

.kwsdk-top-50 {
  top: 50% !important;
}

.kwsdk-top-100 {
  top: 100% !important;
}

.kwsdk-top-auto {
  top: auto !important;
}

.kwsdk-bottom-0 {
  bottom: 0 !important;
}

.kwsdk-bottom-50 {
  bottom: 50% !important;
}

.kwsdk-bottom-100 {
  bottom: 100% !important;
}

.kwsdk-bottom-auto {
  bottom: auto !important;
}

.kwsdk-start-0 {
  inset-inline-start: 0 !important;
}

.kwsdk-start-50 {
  inset-inline-start: 50% !important;
}

.kwsdk-start-100 {
  inset-inline-start: 100% !important;
}

.kwsdk-start-auto {
  inset-inline-start: auto !important;
}

.kwsdk-end-0 {
  inset-inline-end: 0 !important;
}

.kwsdk-end-50 {
  inset-inline-end: 50% !important;
}

.kwsdk-end-100 {
  inset-inline-end: 100% !important;
}

.kwsdk-end-auto {
  inset-inline-end: auto !important;
}

.kwsdk-w-25 {
  width: 25% !important;
}

.kwsdk-h-25 {
  height: 25% !important;
}

.kwsdk-w-50 {
  width: 50% !important;
}

.kwsdk-h-50 {
  height: 50% !important;
}

.kwsdk-w-75 {
  width: 75% !important;
}

.kwsdk-h-75 {
  height: 75% !important;
}

.kwsdk-w-100 {
  width: 100% !important;
}

.kwsdk-h-100 {
  height: 100% !important;
}

.kwsdk-w-auto {
  width: auto !important;
}

.kwsdk-h-auto {
  height: auto !important;
}

.kwsdk-mw-100 {
  max-width: 100% !important;
}

.kwsdk-mh-100 {
  max-height: 100% !important;
}

.kwsdk-size-20 {
  width: 20px !important;
  height: 20px !important;
}

.kwsdk-size-40 {
  width: 40px !important;
  height: 40px !important;
}

.kwsdk-border {
  border: 1px solid var(--sdk-gloabl-border-color) !important;
}

.kwsdk-border-0 {
  border: 0 !important;
}

.kwsdk-border-top {
  border-top: 1px solid var(--sdk-gloabl-border-color) !important;
}

.kwsdk-border-bottom {
  border-bottom: 1px solid var(--sdk-gloabl-border-color) !important;
}

.kwsdk-rounded {
  border-radius: 0.375rem !important;
}

.kwsdk-rounded-0 {
  border-radius: 0 !important;
}

.kwsdk-rounded-1 {
  border-radius: 0.25rem !important;
}

.kwsdk-rounded-2 {
  border-radius: 0.375rem !important;
}

.kwsdk-rounded-3 {
  border-radius: 0.5rem !important;
}

.kwsdk-rounded-4 {
  border-radius: 0.75rem !important;
}

.kwsdk-rounded-circle {
  border-radius: 50% !important;
}

.kwsdk-rounded-pill {
  border-radius: 50rem !important;
}

.kwsdk-shadow-none {
  box-shadow: none !important;
}

.kwsdk-shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.kwsdk-shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.kwsdk-shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.kwsdk-visible {
  visibility: visible !important;
}

.kwsdk-invisible {
  visibility: hidden !important;
}

.kwsdk-z-0 {
  z-index: 0 !important;
}

.kwsdk-z-1 {
  z-index: 1 !important;
}

.kwsdk-z-2 {
  z-index: 2 !important;
}

.kwsdk-z-3 {
  z-index: 3 !important;
}

.kwsdk-z-4 {
  z-index: 4 !important;
}

.kwsdk-z-5 {
  z-index: 5 !important;
}

.kwsdk-z-10 {
  z-index: 10 !important;
}

.kwsdk-z-50 {
  z-index: 50 !important;
}

.kwsdk-z-100 {
  z-index: 100 !important;
}

.kwsdk-z-1000 {
  z-index: 1000 !important;
}

.kwsdk-z-1020 {
  z-index: 1020 !important;
}

.kwsdk-z-1030 {
  z-index: 1030 !important;
}

.kwsdk-z-1040 {
  z-index: 1040 !important;
}

.kwsdk-z-1050 {
  z-index: 1050 !important;
}

.kwsdk-user-select-all {
  user-select: all !important;
}

.kwsdk-user-select-auto {
  user-select: auto !important;
}

.kwsdk-user-select-none {
  user-select: none !important;
}

.kwsdk-pe-none {
  pointer-events: none !important;
}

.kwsdk-pe-auto {
  pointer-events: auto !important;
}

.kwsdk-btn-link {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--sdk-global-theme-color);
  padding: 0;
  margin: 0;
}

.kwsdk-bg-white {
  background-color: var(--sdk-global-white-bg);
}

.kwsdk-bg-transparent {
  background-color: transparent;
}

.kwsdk-bg-secondary {
  background-color: var(--sdk-gloabl-bg-secondary) !important;
}

.kwsdk-text-primary {
  color: var(--sdk-global-primary-text) !important;
}

.kwsdk-text-secondary {
  color: var(--sdk-global-secondary-text) !important;
}

.kwsdk-bg-button {
  background-color: var(--button-bg-color) !important;
}

.kore-chat-window-main-section {
  position: fixed;
  height: calc(100% - 136px);
  border-radius: 4px;
  right: 40px;
  bottom: 96px;
  top: auto;
  width: 400px;
  max-width: calc(100% - 80px);
  transition: 0.4s all ease;
  font-family: var(--global-font-family);
}
.kore-chat-window-main-section.is-wigets-enabled {
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  width: 444px;
}
.kore-chat-window-main-section.is-wigets-enabled .chat-widgetwrapper-main-container {
  border-radius: 0px 4px 4px 0px;
  box-shadow: none !important;
}
.kore-chat-window-main-section.is-wigets-enabled .chat-widgetwrapper-main-container .chat-widget-header {
  border-radius: 0px 4px 0px 0px;
}
.kore-chat-window-main-section.avatar-medium-size {
  height: calc(100% - 148px);
  bottom: 108px;
}
.kore-chat-window-main-section.avatar-medium-size .avatar-variations-footer .avatar-actions.variation-4 .avatar-bg::before {
  left: 4px;
  right: -35px;
  transform: rotate(0);
  bottom: 4px;
}
.kore-chat-window-main-section.avatar-medium-size .avatar-variations-footer .avatar-actions.variation-2 .avatar-bg {
  width: 68px;
}
.kore-chat-window-main-section.avatar-medium-size .avatar-variations-footer .avatar-actions .avatar-bg {
  width: 60px;
  height: 60px;
}
.kore-chat-window-main-section.avatar-large-size {
  height: calc(100% - 160px);
  bottom: 120px;
}
.kore-chat-window-main-section.avatar-large-size .avatar-variations-footer .avatar-actions.variation-4 .avatar-bg::before {
  left: 12px;
  right: -37px;
  transform: rotate(0);
  bottom: 6px;
}
.kore-chat-window-main-section.avatar-large-size .avatar-variations-footer .avatar-actions .avatar-bg {
  width: 72px;
  height: 72px;
}
.kore-chat-window-main-section.no-avatar-bg-icon {
  height: calc(100% - 80px);
}
@media (max-width: 600px) {
  .kore-chat-window-main-section {
    width: calc(100% - 20px);
    height: calc(100% - 115px);
    right: 10px;
    bottom: 40px;
    max-width: 100%;
  }
}
@media (max-height: 300px) {
  .kore-chat-window-main-section {
    /* Approx. 200% zoom */
    height: 100%;
    bottom: 0px;
  }
}
.kore-chat-window-main-section.minimize-chat {
  height: 0px;
  width: 0px;
  top: auto;
}
.kore-chat-window-main-section.minimize-chat .welcome-chat-section {
  transform: scale(0);
}
.kore-chat-window-main-section.minimize-chat .kr-wiz-menu-chat {
  display: none !important;
}
.kore-chat-window-main-section.minimize-chat .kr-wiz-menu-chat.show {
  display: none !important;
}
.kore-chat-window-main-section .kr-wiz-menu-chat {
  display: none;
  float: left;
  transition: ease-in 0.33s;
}
.kore-chat-window-main-section .kr-wiz-menu-chat.show {
  display: block;
}
.kore-chat-window-main-section .kore-sdk-error-section {
  display: block;
  text-align: center;
  background: #FEF3F2;
  color: #B42318;
  font-size: var(--font-size-text-xs, 12px);
  font-weight: var(--font-weight-normal-Medium, 500);
  line-height: var(--font-line-height-text-xs, 16px);
  padding: 8px;
}
.kore-chat-window-main-section .kore-sdk-error-section.hide {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/base/reset.scss","webpack://./src/templatemanager/base/chatContainer/chatContainer.scss","webpack://./src/templatemanager/base/animations.scss","webpack://./src/templatemanager/base/variables.scss","webpack://./src/templatemanager/base/typography.scss","webpack://./src/templatemanager/base/utilities.scss"],"names":[],"mappings":"AACA;;;CAAA;AAKE;EACE,sBAAA;EACA,sCAAA;EACA,cAAA;EACA,eAAA;ACDJ;ADsBA;;;;;;;;;;;;EAYC,SAAA;EACA,UAAA;EACA,SAAA;EACA,wBAAA;ACpBD;ADsBA;EACE,iBAAA;ACpBF;ADxBA;EA8CA,gDAAA;ACnBA;ADwBA;EACC,mBAAA;ACtBD;ADwBA;EACC,gBAAA;ACtBD;ADwBA;EACC,YAAA;ACtBD;ADwBA;;EAEC,WAAA;EACA,aAAA;ACtBD;ADwBA;EAEC,iBAAA;ACvBD;ADyBA;EACC,4CAAA;EACG,mBAAA;EACA,mBAAA;ACvBJ;ADiCC;EACC,4CAAA;EACA,mBAAA;EACA,mBAAA;EACA,gDAAA;AC/BF;ADkCA;EACC,eAAA;AChCD;AD1DA;EA6FA,4DAAA;AChCA;ADiCA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AC/BJ;ADiCE;EACE,UAAA;EACA,WAAA;EACA,eAAA;AC/BJ;ADiCE;EACE,yCAAA;EACA,kBAAA;EACA,gEAAA;EACA,wEAAA;AC/BJ;ADiCE;;EAEC,wBAAA;EACA,SAAA;AC/BH;ADlFA;EAoHE,YAAA;AC/BF;ADgCE;EACD,0BAAA;AC9BD;ADxFA;EAwHE,0DAAA;AC7BF;;ADgCA;EACE,wBAAA;AC7BF;;AClGA;EACI;IACE,gBAAA;EDqGJ;ECnGE;IACI,iBAAA;EDqGN;AACF;AClGA;EACI;IAAyB,wBAAA;EDqG3B;ECpGE;IAAK,4BAAA;EDuGP;ECtGE;IAAK,4BAAA;EDyGP;AACF;ACxGA;EACI;IACE,UAAA;IACA,qBAAA;ED0GJ;ECxGE;IACE,UAAA;IACA,mBAAA;ED0GJ;ECxGE;IAAM,2BAAA;ED2GR;EC1GE;IAAO,gCAAA;ED6GT;AACF;AC3GA;EACI;IACE,UAAA;IACA,2BAAA,EAAA,gCAAA;ED6GJ;EC3GE;IACI,UAAA;IACA,4BAAA,EAAA,iDAAA;ED6GN;EC3GE;IACE,UAAA;IACA,uBAAA,EAAA,iDAAA;ED6GJ;AACF;AC1GA;EACI;IACI,UAAA;IACA,2BAAA,EAAA,gCAAA;ED4GN;EC1GE;IACI,UAAA;IACA,uBAAA,EAAA,iDAAA;ED4GN;AACF;ACtGA;EACI;IACE,UAAA;IACA,mBAAA;IACA,gBAAA;EDwGJ;ECtGE;IACE,gBAAA;EDwGJ;ECtGE;IACI,UAAA;IACA,mBAAA;IACA,iBAAA;EDwGN;AACF;ACtGA;EACI;IACE,UAAA;IACA,gBAAA;EDwGJ;ECtGE;IACE,UAAA;IACA,gBAAA;EDwGJ;ECtGE;IACE,2BAAA;EDwGJ;ECtGE;IACE,2BAAA;EDwGJ;ECtGE;IACE,eAAA;IACA,iBAAA;EDwGJ;AACF;ACjGA;EACI;IACE,UAAA;IACA,0BAAA;EDmGJ;ECjGE;IACE,UAAA;IACA,0BAAA;EDmGJ;ECjGE;IACE,UAAA;IACA,wBAAA;EDmGJ;AACF;AC5FA;EACE;IACE,UAAA;IACA,2BAAA;ED8FF;EC5FA;IACE,UAAA;IACA,wBAAA;ED8FF;AACF;ACzFA;EACI;IACE,UAAA;IACA,4BAAA;ED2FJ;ECzFE;IACI,YAAA;IACA,0BAAA;ED2FN;ECzFE;IACE,UAAA;IACA,uBAAA;ED2FJ;AACF;ACpFA;EACI;IACE,UAAA;IACA,2BAAA,EAAA,gCAAA;EDsFJ;ECpFE;IACI,YAAA;IACA,2BAAA,EAAA,iDAAA;EDsFN;ECpFE;IACE,UAAA;IACA,uBAAA,EAAA,iDAAA;EDsFJ;AACF;ACjFA;EACI;IACI,qBAAA;IACA,gJAAA;EDmFN;EC7EE;IACI,eAAA;ED+EN;EC5EE;IACI,qBAAA;IACA,6IAAA;ED8EN;AACF;ACxEA;EACI;IACI,qBAAA;ED0EN;ECxEE;IACI,gJAAA;ED0EN;ECpEI;IACE,eAAA;EDsEN;ECpEI;IACE,8IAAA;IAKA,qBAAA;EDkEN;EChEE;IACI,qBAAA;EDkEN;AACF;AC3DA;EACI;IACE,yBAAA;ED6DJ;EC3DE;IACI,UAAA;IACA,2BAAA;IACA,aAAA;ED6DN;AACF;AC3DA;EACI;IACE,UAAA;IACA,2BAAA;ED6DJ;EC3DE;IACI,UAAA;IACA,4BAAA;ED6DN;EC3DE;IACE,UAAA;IACA,uBAAA;ED6DJ;AACF;ACrDA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADuDF;;ACpDA;EACE;IACE,UAAA;IACA,yCAAA;IACA,iCAAA;EDuDF;ECrDA;IACE,UAAA;EDuDF;AACF;ACpDA;EACE;IACE,UAAA;IACA,yCAAA;IACA,iCAAA;EDsDF;ECpDA;IACE,UAAA;EDsDF;AACF;AC/CA;EACE,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADiDF;;AC9CA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,mBAAA;EDiDF;EC/CA;IACE,gCAAA;IACA,0BAAA;EDiDF;EC/CA;IACE,gCAAA;IACA,wBAAA;EDiDF;AACF;AC9CA;EACE;IACE,mCAAA;IACA,2BAAA;IACA,mBAAA;EDgDF;EC9CA;IACE,gCAAA;IACA,0BAAA;EDgDF;EC9CA;IACE,gCAAA;IACA,wBAAA;EDgDF;AACF;AC7CA;EACC,4EAAA;EACQ,oEAAA;AD+CT;;AC5CA;EACC,+EAAA;EACQ,uEAAA;AD+CT;;AC5CC;EACC;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ED+CF;EC7CA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ED+CF;AACF;AC5CA;EACE;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ED8CF;EC5CA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;IACR,UAAA;ED8CF;AACF;AC1CA;EACA;IACE,6BAAA;IACQ,qBAAA;IACR,mCAAA;IACQ,2BAAA;ED4CR;EC1CF;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;ED4CR;AACF;ACzCA;EACE;IACE,6BAAA;IACQ,qBAAA;IACR,mCAAA;IACQ,2BAAA;ED2CV;ECzCA;IACE,2BAAA;IACQ,mBAAA;IACR,mCAAA;IACQ,2BAAA;ED2CV;AACF;ACrCA;EACE;IAAK,+BAAA;EDwCL;ECvCA;IAAO,iCAAA;ED0CP;AACF;ACxCA;EACE;IAAK,uBAAA;ED2CL;EC1CA;IAAO,yBAAA;ED6CP;AACF;ACxCA;EACE,gCAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,iCAAA;EACA,yBAAA;AD0CF;;ACvCA;EACE;IACE,gCAAA;IACA,wBAAA;IACA,6CAAA;IACA,qCAAA;IACA,UAAA;ED0CF;ECvCA;IACE,gCAAA;IACA,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EDyCF;AACF;ACtCA;EACE;IACE,gCAAA;IACA,wBAAA;IACA,6CAAA;IACA,qCAAA;IACA,UAAA;EDwCF;ECrCA;IACE,gCAAA;IACA,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EDuCF;AACF;ACjCA;EACE;IACI,gDAAA;EDmCJ;ECjCA;IACI,YAAA;EDmCJ;AACF;AC9BA;EACE,8BAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;EACA,aAAA;ADgCF;;AC7BA;EACE;IACE,UAAA;EDgCF;EC7BA;IACE,UAAA;ED+BF;AACF;AC5BA;EACE;IACE,UAAA;ED8BF;EC3BA;IACE,UAAA;ED6BF;AACF;ACvBA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADyBF;;ACtBA;EAEE;IAKE,uEAAA;IACA,+DAAA;EDoBF;ECjBA;IACE,UAAA;IACA,4CAAA;IACA,oCAAA;EDmBF;EChBA;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EDkBF;ECfA;IACE,0CAAA;IACA,kCAAA;EDiBF;ECdA;IACE,0CAAA;IACA,kCAAA;EDgBF;ECbA;IACE,uCAAA;IACA,+BAAA;EDeF;AACF;ACZA;EAEE;IAKE,uEAAA;IACA,+DAAA;EDSF;ECNA;IACE,UAAA;IACA,4CAAA;IACA,oCAAA;EDQF;ECLA;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EDOF;ECJA;IACE,0CAAA;IACA,kCAAA;EDMF;ECHA;IACE,0CAAA;IACA,kCAAA;EDKF;ECFA;IACE,uCAAA;IACA,+BAAA;EDIF;AACF;ACCA;EACE,kCAAA;EACA,0BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADCF;;ACEA;EACE;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EDCF;ECEA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EDAF;AACF;ACGA;EACE;IACE,UAAA;IACA,2CAAA;IACA,mCAAA;EDDF;ECIA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EDFF;AACF;ACOA;EACE,gCAAA;EACA,wBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADLF;;ACQA;EACE;IACE,UAAA;IACA,0CAAA;IACA,kCAAA;EDLF;ECQA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EDNF;AACF;ACSA;EACE;IACE,UAAA;IACA,0CAAA;IACA,kCAAA;EDPF;ECUA;IACE,UAAA;IACA,uBAAA;IACA,eAAA;EDRF;AACF;ACaA;EACE,+BAAA;EACA,uBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADXF;;ACcA;EACE;IACE,UAAA;EDXF;ECcA;IACE,UAAA;EDZF;AACF;ACeA;EACE;IACE,UAAA;EDbF;ECgBA;IACE,UAAA;EDdF;AACF;ACiBA;EACI,oCAAA;EACA,4BAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;ADfJ;;ACiBE;EACE;IACE,mCAAA;IACA,2BAAA;EDdJ;ECgBE;IACE,gCAAA;IACA,wBAAA;EDdJ;AACF;AE3rBA;EAGI,yEAAA;EACA,6EAAA;EACA,uEAAA;EACA,2EAAA;EAII,qEAAA;EACA,yEAAA;EACA,sEAAA;EACA,2EAAA;EAGA,0EAAA;EACA,8EAAA;EACA,8EAAA;EACA,kFAAA;EAEA,kEAAA;EACA,oFAAA;EACA,oCAAA;EACA,kFAAA;EACA,+FAAA;EACA,qFAAA;EACA,kGAAA;EAMA,kEAAA;EAGJ,wDAAA;EACA,2DAAA;EACA,mDAAA;EACA,qEAAA;EACA,sDAAA;EACA,2DAAA;EACA,2DAAA;EACA,iDAAA;EAGI,kEAAA;EACA,2EAAA;EACA,4EAAA;EACA,+CAAA;EAIA,gEAAA;EAIA,gDAAA;EACA,oDAAA;EACA,sDAAA;EAIA,uCAAA;EACA,qDAAA;EACA,8EAAA;EACA,oFAAA;EACA,kDAAA;EACA,0DAAA;EACA,yDAAA;EACA,2DAAA;EACA,+DAAA;EACA,4DAAA;EACA,oEAAA;EACA,gEAAA;EACA,yDAAA;EACA,iEAAA;EACA,2GAAA;EACA,gEAAA;EACA,4GAAA;EACA,oFAAA;EACA,yDAAA;EAIA,oEAAA;EACA,0DAAA;EACA,4JAAA;EACA,gEAAA;EACA,mEAAA;EACA,gFAAA;EACA,mFAAA;EACA,+EAAA;EACA,uDAAA;EAIA,kEAAA;EAIA,mDAAA;EACA,yEAAA;EACA,+DAAA;EACA,4FAAA;EACA,qGAAA;EACA,sEAAA;EACA,kFAAA;EACA,4EAAA;EACA,qEAAA;EACA,sEAAA;EACA,kEAAA;EACA,uEAAA;EACA,oFAAA;EACA,6EAAA;EACA,8EAAA;EACA,uQAAA;EACA,sQAAA;EACA,0FAAA;EACA,kFAAA;EAIA,oDAAA;EACA,uEAAA;EACA,6EAAA;EACA,uEAAA;EACA,kDAAA;EAIA,qEAAA;EAIA,kEAAA;EAIA,sDAAA;EACA,0EAAA;EACA,gFAAA;EACA,0EAAA;EACA,oDAAA;EACA,6CAAA;EAIA,kDAAA;EACA,sDAAA;EACA,2DAAA;EACA,mDAAA;EAIA,kEAAA;EACA,iEAAA;EAMA,2CAAA;EACA,mDAAA;EACA,gDAAA;EACA,qDAAA;EACA,2DAAA;EACA,4CAAA;EACA,sDAAA;EACA,kJAAA;EACA,mDAAA;EACA,uDAAA;EACA,wDAAA;EACA,kIAAA;EAIA,qDAAA;EACA,yDAAA;EACA,iDAAA;EACA,iDAAA;EACA,yCAAA;EACA,8CAAA;EACA,iDAAA;EACA,gDAAA;EACA,mDAAA;EACA,yDAAA;EACA,0DAAA;EACA,4DAAA;EAIA,6CAAA;EACA,oDAAA;EACA,+CAAA;EACA,mEAAA;EACA,0DAAA;EAGA,6CAAA;EACA,sDAAA;EACA,iDAAA;EACA,oDAAA;EAII,kDAAA;EACA,6CAAA;EACA,qCAAA;EACA,iEAAA;AFwnBZ;;AEhlBA;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,6CAAA;EACA,uDAAA;EACA,2CAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AFmlBJ;AEllBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AFolBR;AEllBI;EACI,mDAAA;AFolBR;AEllBI;EACI,YAAA;EACA,oBAAA;AFolBR;;AEjlBA;EACI,WAAA;EACA,iCAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AFolBJ;AEnlBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AFqlBR;AEnlBI;EACI,uCAAA;AFqlBR;;AEjlBA;EACI,WAAA;EACA,kCAAA;EACA,wCAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AFolBJ;AEllBQ;EACI,4BAAA;AFolBZ;AEjlBI;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AFmlBR;AEjlBI;EACI,kCAAA;AFmlBR;;AE9kBI;EACI,kCAAA;EACA,eAAA;AFilBR;AE/kBI;EACI,oCAAA;AFilBR;AE/kBI;EACI,kCAAA;EACA,eAAA;AFilBR;AE/kBI;EACI,oCAAA;AFilBR;AE9kBQ;EACI,kCAAA;EACA,eAAA;AFglBZ;AE7kBI;EACI,kCAAA;EACA,eAAA;AF+kBR;;AG73BC;EA1DA,eA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AH27BD;AGt7BC;EACC,gBAAA;AHw7BF;AGt7BC;EACC,gBAAA;AHw7BF;AGt7BC;EACC,gBAAA;AHw7BF;;AG/4BC;EA1DA,eA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AH68BD;AGx8BC;EACC,gBAAA;AH08BF;AGx8BC;EACC,gBAAA;AH08BF;AGx8BC;EACC,gBAAA;AH08BF;;AGj6BC;EA1DA,eA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AH+9BD;AG19BC;EACC,gBAAA;AH49BF;AG19BC;EACC,gBAAA;AH49BF;AG19BC;EACC,gBAAA;AH49BF;;AGn7BC;EA1DA,eA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AHi/BD;AG5+BC;EACC,gBAAA;AH8+BF;AG5+BC;EACC,gBAAA;AH8+BF;AG5+BC;EACC,gBAAA;AH8+BF;;AGr8BC;EA1DA,eA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AHmgCD;AG9/BC;EACC,gBAAA;AHggCF;AG9/BC;EACC,gBAAA;AHggCF;AG9/BC;EACC,gBAAA;AHggCF;;AGv9BC;EA1DA,eA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AHqhCD;AGhhCC;EACC,gBAAA;AHkhCF;AGhhCC;EACC,gBAAA;AHkhCF;AGhhCC;EACC,gBAAA;AHkhCF;;AGz+BC;EA1DA,cA8DS;EA7DT,mDAPS;EAQT,iBA6De;EA5Df,mCAoDY;EAnDZ,iBA6Dc;EA5Dd,SAAA;AHuiCD;AGliCC;EACC,gBAAA;AHoiCF;AGliCC;EACC,gBAAA;AHoiCF;AGliCC;EACC,gBAAA;AHoiCF;;AIniCC;EACC,wBAAA;AJsiCF;;AIviCC;EACC,0BAAA;AJ0iCF;;AI3iCC;EACC,gCAAA;AJ8iCF;;AI/iCC;EACC,yBAAA;AJkjCF;;AInjCC;EACC,wBAAA;AJsjCF;;AIvjCC;EACC,+BAAA;AJ0jCF;;AI3jCC;EACC,wBAAA;AJ8jCF;;AI/jCC;EACC,+BAAA;AJkkCF;;AInkCC;EACC,yBAAA;AJskCF;;AIvkCC;EACC,6BAAA;AJ0kCF;;AI3kCC;EACC,8BAAA;AJ8kCF;;AIjkCC;EACC,mBATmB;AJ6kCrB;;AIrkCC;EACC,sBATmB;AJilCrB;;AIzkCC;EACC,2BATmB;AJqlCrB;;AI7kCC;EACC,8BATmB;AJylCrB;;AIlkCC;EACC,2BAXW;AJglCb;;AItkCC;EACC,yBAXW;AJolCb;;AI1kCC;EACC,uBAXW;AJwlCb;;AI9kCC;EACC,8BAXW;AJ4lCb;;AIllCC;EACC,6BAXW;AJgmCb;;AItlCC;EACC,6BAXW;AJomCb;;AI5kCC;EACC,uBAVe;AJylCjB;;AIhlCC;EACC,qBAVe;AJ6lCjB;;AIplCC;EACC,mBAVe;AJimCjB;;AIxlCC;EACC,qBAVe;AJqmCjB;;AI5lCC;EACC,oBAVe;AJymCjB;;AIjlCC;EACC,yBAXiB;AJ+lCnB;;AIrlCC;EACC,uBAXiB;AJmmCnB;;AIzlCC;EACC,qBAXiB;AJumCnB;;AI7lCC;EACC,4BAXiB;AJ2mCnB;;AIjmCC;EACC,2BAXiB;AJ+mCnB;;AIrmCC;EACC,sBAXiB;AJmnCnB;;AI1lCC;EACC,gBAXc;AJwmChB;;AI9lCC;EACC,sBAXc;AJ4mChB;;AIlmCC;EACC,oBAXc;AJgnChB;;AItmCC;EACC,kBAXc;AJonChB;;AI1mCC;EACC,oBAXc;AJwnChB;;AI9mCC;EACC,mBAXc;AJ4nChB;;AItmCC;EACC,eARa;AJinCf;;AI1mCC;EACC,iBARa;AJqnCf;;AI9mCC;EACC,uBARa;AJynCf;;AI7mCA;EACC,cAAA;AJgnCD;;AI9mCA;EACC,YAAA;AJinCD;;AI/mCA;EACC,YAAA;AJknCD;;AIhnCA;EACC,cAAA;AJmnCD;;AIjnCA;EACC,cAAA;AJonCD;;AIhnCC;EACC,QAFW;AJqnCb;;AIpnCC;EACC,QAFW;AJynCb;;AIxnCC;EACC,QAFW;AJ6nCb;;AI5nCC;EACC,QAFW;AJioCb;;AIhoCC;EACC,QAFW;AJqoCb;;AIpoCC;EACC,QAFW;AJyoCb;;AIpoCA;EACC,SAAA;AJuoCD;;AIroCA;EACC,QAAA;AJwoCD;;AInoCE;EACC,MApJU;AJ0xCb;;AIpoCE;EACC,UAvJU;AJ8xCb;;AIroCE;EACC,aA1JU;AJkyCb;;AI/oCE;EACC,YApJU;AJsyCb;;AIhpCE;EACC,gBAvJU;AJ0yCb;;AIjpCE;EACC,mBA1JU;AJ8yCb;;AI3pCE;EACC,WApJU;AJkzCb;;AI5pCE;EACC,eAvJU;AJszCb;;AI7pCE;EACC,kBA1JU;AJ0zCb;;AIvqCE;EACC,YApJU;AJ8zCb;;AIxqCE;EACC,gBAvJU;AJk0Cb;;AIzqCE;EACC,mBA1JU;AJs0Cb;;AInrCE;EACC,SApJU;AJ00Cb;;AIprCE;EACC,aAvJU;AJ80Cb;;AIrrCE;EACC,gBA1JU;AJk1Cb;;AI/rCE;EACC,YApJU;AJs1Cb;;AIhsCE;EACC,gBAvJU;AJ01Cb;;AIjsCE;EACC,mBA1JU;AJ81Cb;;AI3sCE;EACC,WApJU;AJk2Cb;;AI5sCE;EACC,eAvJU;AJs2Cb;;AI7sCE;EACC,kBA1JU;AJ02Cb;;AIvsCG;EAEE,oBAAA;AJysCL;;AI3sCG;EAEE,0BAAA;AJ6sCL;;AI/sCG;EAEE,yBAAA;AJitCL;;AIntCG;EAEE,0BAAA;AJqtCL;;AIvtCG;EAEE,uBAAA;AJytCL;;AI3tCG;EAEE,0BAAA;AJ6tCL;;AI/tCG;EAEE,yBAAA;AJiuCL;;AInuCG;EAEE,uBAAA;AJquCL;;AIvuCG;EAEE,wBAAA;AJyuCL;;AI3uCG;EAEE,8BAAA;AJ6uCL;;AI/uCG;EAEE,6BAAA;AJivCL;;AInvCG;EAEE,8BAAA;AJqvCL;;AIvvCG;EAEE,2BAAA;AJyvCL;;AI3vCG;EAEE,8BAAA;AJ6vCL;;AI/vCG;EAEE,6BAAA;AJiwCL;;AInwCG;EAEE,2BAAA;AJqwCL;;AIvwCG;EAEE,2BAAA;AJywCL;;AI3wCG;EAEE,iCAAA;AJ6wCL;;AI/wCG;EAEE,gCAAA;AJixCL;;AInxCG;EAEE,iCAAA;AJqxCL;;AIvxCG;EAEE,8BAAA;AJyxCL;;AI3xCG;EAEE,iCAAA;AJ6xCL;;AI/xCG;EAEE,gCAAA;AJiyCL;;AInyCG;EAEE,8BAAA;AJqyCL;;AIvyCG;EAEE,iCAAA;AJyyCL;;AI3yCG;EAEE,uCAAA;AJ6yCL;;AI/yCG;EAEE,sCAAA;AJizCL;;AInzCG;EAEE,uCAAA;AJqzCL;;AIvzCG;EAEE,oCAAA;AJyzCL;;AI3zCG;EAEE,uCAAA;AJ6zCL;;AI/zCG;EAEE,sCAAA;AJi0CL;;AIn0CG;EAEE,oCAAA;AJq0CL;;AIv0CG;EAEE,+BAAA;AJy0CL;;AI30CG;EAEE,qCAAA;AJ60CL;;AI/0CG;EAEE,oCAAA;AJi1CL;;AIn1CG;EAEE,qCAAA;AJq1CL;;AIv1CG;EAEE,kCAAA;AJy1CL;;AI31CG;EAEE,qCAAA;AJ61CL;;AI/1CG;EAEE,oCAAA;AJi2CL;;AIn2CG;EAEE,kCAAA;AJq2CL;;AIv2CG;EAEE,qBAAA;AJy2CL;;AI32CG;EAEE,2BAAA;AJ62CL;;AI/2CG;EAEE,0BAAA;AJi3CL;;AIn3CG;EAEE,2BAAA;AJq3CL;;AIv3CG;EAEE,wBAAA;AJy3CL;;AI33CG;EAEE,2BAAA;AJ63CL;;AI/3CG;EAEE,0BAAA;AJi4CL;;AIn4CG;EAEE,yBAAA;AJq4CL;;AIv4CG;EAEE,+BAAA;AJy4CL;;AI34CG;EAEE,8BAAA;AJ64CL;;AI/4CG;EAEE,+BAAA;AJi5CL;;AIn5CG;EAEE,4BAAA;AJq5CL;;AIv5CG;EAEE,+BAAA;AJy5CL;;AI35CG;EAEE,8BAAA;AJ65CL;;AI/5CG;EAEE,4BAAA;AJi6CL;;AIn6CG;EAEE,kCAAA;AJq6CL;;AIv6CG;EAEE,iCAAA;AJy6CL;;AI36CG;EAEE,kCAAA;AJ66CL;;AI/6CG;EAEE,+BAAA;AJi7CL;;AIn7CG;EAEE,kCAAA;AJq7CL;;AIv7CG;EAEE,iCAAA;AJy7CL;;AI37CG;EAEE,kCAAA;AJ67CL;;AI/7CG;EAEE,wCAAA;AJi8CL;;AIn8CG;EAEE,uCAAA;AJq8CL;;AIv8CG;EAEE,wCAAA;AJy8CL;;AI38CG;EAEE,qCAAA;AJ68CL;;AI/8CG;EAEE,wCAAA;AJi9CL;;AIn9CG;EAEE,uCAAA;AJq9CL;;AIv9CG;EAEE,gCAAA;AJy9CL;;AI39CG;EAEE,sCAAA;AJ69CL;;AI/9CG;EAEE,qCAAA;AJi+CL;;AIn+CG;EAEE,sCAAA;AJq+CL;;AIv+CG;EAEE,mCAAA;AJy+CL;;AI3+CG;EAEE,sCAAA;AJ6+CL;;AI/+CG;EAEE,qCAAA;AJi/CL;;AI79CE;EACC,kCAAA;EACA,gCAAA;AJg+CH;;AI99CE;EACC,yBAAA;EACA,4BAAA;AJi+CH;;AI99CC;EACC,iCAAA;EACA,+BAAA;AJi+CF;;AI/9CC;EACC,wBAAA;EACA,2BAAA;AJk+CF;;AIj/CE;EACC,wCAAA;EACA,sCAAA;AJo/CH;;AIl/CE;EACC,+BAAA;EACA,kCAAA;AJq/CH;;AIl/CC;EACC,uCAAA;EACA,qCAAA;AJq/CF;;AIn/CC;EACC,8BAAA;EACA,iCAAA;AJs/CF;;AIrgDE;EACC,uCAAA;EACA,qCAAA;AJwgDH;;AItgDE;EACC,8BAAA;EACA,iCAAA;AJygDH;;AItgDC;EACC,sCAAA;EACA,oCAAA;AJygDF;;AIvgDC;EACC,6BAAA;EACA,gCAAA;AJ0gDF;;AIzhDE;EACC,wCAAA;EACA,sCAAA;AJ4hDH;;AI1hDE;EACC,+BAAA;EACA,kCAAA;AJ6hDH;;AI1hDC;EACC,uCAAA;EACA,qCAAA;AJ6hDF;;AI3hDC;EACC,8BAAA;EACA,iCAAA;AJ8hDF;;AI7iDE;EACC,qCAAA;EACA,mCAAA;AJgjDH;;AI9iDE;EACC,4BAAA;EACA,+BAAA;AJijDH;;AI9iDC;EACC,oCAAA;EACA,kCAAA;AJijDF;;AI/iDC;EACC,2BAAA;EACA,8BAAA;AJkjDF;;AIjkDE;EACC,wCAAA;EACA,sCAAA;AJokDH;;AIlkDE;EACC,+BAAA;EACA,kCAAA;AJqkDH;;AIlkDC;EACC,uCAAA;EACA,qCAAA;AJqkDF;;AInkDC;EACC,8BAAA;EACA,iCAAA;AJskDF;;AIrlDE;EACC,uCAAA;EACA,qCAAA;AJwlDH;;AItlDE;EACC,8BAAA;EACA,iCAAA;AJylDH;;AItlDC;EACC,sCAAA;EACA,oCAAA;AJylDF;;AIvlDC;EACC,6BAAA;EACA,gCAAA;AJ0lDF;;AIhmDC;EACC,oCAAA;EACA,kCAAA;AJmmDF;;AIjmDC;EACC,2BAAA;EACA,8BAAA;AJomDF;;AI/lDA;EACC,4BAAA;AJkmDD;;AIhmDA;EACC,0BAAA;AJmmDD;;AIjmDA;EACC,6BAAA;AJomDD;;AIjmDA;EACC,oCAAA;AJomDD;;AIlmDA;EACC,oCAAA;AJqmDD;;AInmDA;EACC,qCAAA;AJsmDD;;AInmDA;EACC,2BAAA;AJsmDD;;AIpmDA;EACC,2BAAA;AJumDD;;AIrmDA;EACC,2BAAA;AJwmDD;;AItmDA;EACC,2BAAA;AJymDD;;AIvmDA;EACC,2BAAA;AJ0mDD;;AIvmDA;EACC,6BAAA;AJ0mDD;;AIxmDA;EACC,6BAAA;AJ2mDD;;AIxmDA;EACC,8BAAA;AJ2mDD;;AIzmDA;EACC,8BAAA;AJ4mDD;;AI1mDA;EACC,gBAAA;EACA,uBAAA;EACA,8BAAA;AJ6mDD;;AIzmDC;EACC,oBAAA;EACA,4BAAA;EACA,aAJW;EAKX,qBALW;EAMX,gBAAA;AJ4mDF;;AIjnDC;EACC,oBAAA;EACA,4BAAA;EACA,aAJW;EAKX,qBALW;EAMX,gBAAA;AJonDF;;AIznDC;EACC,oBAAA;EACA,4BAAA;EACA,aAJW;EAKX,qBALW;EAMX,gBAAA;AJ4nDF;;AIjoDC;EACC,oBAAA;EACA,4BAAA;EACA,aAJW;EAKX,qBALW;EAMX,gBAAA;AJooDF;;AIzoDC;EACC,oBAAA;EACA,4BAAA;EACA,aAJW;EAKX,qBALW;EAMX,gBAAA;AJ4oDF;;AIxoDA;EACC,gCAAA;AJ2oDD;;AIzoDA;EACC,qCAAA;AJ4oDD;;AI1oDA;EACC,wCAAA;AJ6oDD;;AIvoDC;EACC,yBAAA;AJ0oDF;;AIxoDC;EACC,2BAAA;AJ2oDF;;AIzoDC;EACC,2BAAA;AJ4oDF;;AInpDC;EACC,2BAAA;AJspDF;;AIppDC;EACC,6BAAA;AJupDF;;AIrpDC;EACC,6BAAA;AJwpDF;;AI/pDC;EACC,4BAAA;AJkqDF;;AIhqDC;EACC,8BAAA;AJmqDF;;AIjqDC;EACC,8BAAA;AJoqDF;;AI3qDC;EACC,2BAAA;AJ8qDF;;AI5qDC;EACC,6BAAA;AJ+qDF;;AI7qDC;EACC,6BAAA;AJgrDF;;AI3qDA;EACC,2BAAA;AJ8qDD;;AI5qDA;EACC,6BAAA;AJ+qDD;;AI7qDA;EACC,6BAAA;AJgrDD;;AI9qDA;EACC,0BAAA;AJirDD;;AI/qDA;EACC,2BAAA;AJkrDD;;AI5pDG;EACC,iBAAA;AJ+pDJ;;AIhqDG;EACC,mBAAA;AJmqDJ;;AIpqDG;EACC,oBAAA;AJuqDJ;;AIxqDG;EACC,oBAAA;AJ2qDJ;;AI5qDG;EACC,oBAAA;AJ+qDJ;;AIhrDG;EACC,sBAAA;AJmrDJ;;AIprDG;EACC,uBAAA;AJurDJ;;AIxrDG;EACC,uBAAA;AJ2rDJ;;AIhsDG;EACC,gCAAA;AJmsDJ;;AIpsDG;EACC,kCAAA;AJusDJ;;AIxsDG;EACC,mCAAA;AJ2sDJ;;AI5sDG;EACC,mCAAA;AJ+sDJ;;AIhtDG;EACC,8BAAA;AJmtDJ;;AIptDG;EACC,gCAAA;AJutDJ;;AIxtDG;EACC,iCAAA;AJ2tDJ;;AI5tDG;EACC,iCAAA;AJ+tDJ;;AI7sDC;EACC,qBAAA;AJgtDF;;AI9sDC;EACC,sBAAA;AJitDF;;AIrtDC;EACC,qBAAA;AJwtDF;;AIttDC;EACC,sBAAA;AJytDF;;AI7tDC;EACC,qBAAA;AJguDF;;AI9tDC;EACC,sBAAA;AJiuDF;;AIruDC;EACC,sBAAA;AJwuDF;;AItuDC;EACC,uBAAA;AJyuDF;;AI7uDC;EACC,sBAAA;AJgvDF;;AI9uDC;EACC,uBAAA;AJivDF;;AI7uDA;EACC,0BAAA;AJgvDD;;AI9uDA;EACC,2BAAA;AJivDD;;AI1uDC;EACC,sBAAA;EACA,uBAAA;AJ6uDF;;AI/uDC;EACC,sBAAA;EACA,uBAAA;AJkvDF;;AIzuDA;EACC,2DAAA;AJ4uDD;;AI1uDA;EACC,oBAAA;AJ6uDD;;AI3uDA;EACC,+DAAA;AJ8uDD;;AI5uDA;EACC,kEAAA;AJ+uDD;;AI5uDA;EACC,kCAAA;AJ+uDD;;AI7uDA;EACC,2BAAA;AJgvDD;;AI9uDA;EACC,iCAAA;AJivDD;;AI/uDA;EACC,kCAAA;AJkvDD;;AIhvDA;EACC,gCAAA;AJmvDD;;AIjvDA;EACC,iCAAA;AJovDD;;AIlvDA;EACC,6BAAA;AJqvDD;;AInvDA;EACC,+BAAA;AJsvDD;;AIlvDA;EACC,2BAAA;AJqvDD;;AInvDA;EACC,8DAAA;AJsvDD;;AIpvDA;EACC,wDAAA;AJuvDD;;AIrvDA;EACC,uDAAA;AJwvDD;;AIpvDA;EACC,8BAAA;AJuvDD;;AIrvDA;EACC,6BAAA;AJwvDD;;AInvDC;EACC,qBAAA;AJsvDF;;AIvvDC;EACC,qBAAA;AJ0vDF;;AI3vDC;EACC,qBAAA;AJ8vDF;;AI/vDC;EACC,qBAAA;AJkwDF;;AInwDC;EACC,qBAAA;AJswDF;;AIvwDC;EACC,qBAAA;AJ0wDF;;AI3wDC;EACC,sBAAA;AJ8wDF;;AI/wDC;EACC,sBAAA;AJkxDF;;AInxDC;EACC,uBAAA;AJsxDF;;AIvxDC;EACC,wBAAA;AJ0xDF;;AI3xDC;EACC,wBAAA;AJ8xDF;;AI/xDC;EACC,wBAAA;AJkyDF;;AInyDC;EACC,wBAAA;AJsyDF;;AIvyDC;EACC,wBAAA;AJ0yDF;;AIryDA;EACC,2BAAA;AJwyDD;;AItyDA;EACC,4BAAA;AJyyDD;;AIvyDA;EACC,4BAAA;AJ0yDD;;AIvyDA;EACC,+BAAA;AJ0yDD;;AIxyDA;EACC,+BAAA;AJ2yDD;;AIvyDA;EACC,gBAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,UAAA;EACA,SAAA;AJ0yDD;;AIvyDA;EACC,4CAAA;AJ0yDD;;AIvyDA;EACC,6BAAA;AJ0yDD;;AIvyDA;EACC,2DAAA;AJ0yDD;;AIvyDA;EACC,gDAAA;AJ0yDD;;AIvyDA;EACC,kDAAA;AJ0yDD;;AIvyDA;EACC,mDAAA;AJ0yDD;;AAtxEA;EACE,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,4BAAA;EACA,yBAAA;EACA,sCAAA;AAyxEF;AAxxEE;EACE,mDAAA;EACA,YAAA;AA0xEJ;AAzxEI;EACE,8BAAA;EACA,2BAAA;AA2xEN;AA1xEM;EACE,8BAAA;AA4xER;AAxxEE;EACE,0BAAA;EACA,aAAA;AA0xEJ;AArxEY;EACE,SAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AAuxEd;AAlxEU;EACE,WAAA;AAoxEZ;AAjxEQ;EACE,WAAA;EACA,YAAA;AAmxEV;AA9wEE;EACE,0BAAA;EACA,aAAA;AAgxEJ;AA3wEY;EACE,UAAA;EACA,YAAA;EACA,oBAAA;EACA,WAAA;AA6wEd;AAzwEQ;EACE,WAAA;EACA,YAAA;AA2wEV;AAtwEE;EACE,yBAAA;AAwwEJ;AAtwEE;EA1EF;IA2EI,wBAAA;IACA,0BAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAywEF;AACF;AAxwEE;EAjFF;IAkFI,sBAAA;IACA,YAAA;IACA,WAAA;EA2wEF;AACF;AA1wEE;EACE,WAAA;EACA,UAAA;EACA,SAAA;AA4wEJ;AA3wEI;EACE,mBAAA;AA6wEN;AA3wEI;EACE,wBAAA;AA6wEN;AA5wEM;EACE,wBAAA;AA8wER;AAzwEE;EACE,aAAA;EACF,WAAA;EACA,yBAAA;AA2wEF;AA1wEI;EACE,cAAA;AA4wEN;AAxwEE;EACE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,yCAAA;EACA,kDAAA;EACA,kDAAA;EACA,YAAA;AA0wEJ;AAzwEI;EACE,aAAA;AA2wEN","sourcesContent":["// Reset css\n/* http://meyerweb.com/eric/tools/css/reset/ \n   v2.0 | 20110126\n   License: none (public domain)\n*/\n.kore-chat-window-main-section{\n  *{\n    box-sizing: border-box;\n    font-family: var(--global-font-family);\n    color: inherit;\n    font-size: 100%;\n  }\n// applet, object, iframe,\n// h1, h2, h3, h4, h5, h6, p, blockquote, pre,\n// a, abbr, acronym, address, big, cite, code,\n// del, dfn, em, img, ins, kbd, q, s, samp,\n// small, strike, strong, sub, sup, tt, var,\n// b, u, i, center,\n// dl, dt, dd, ol, ul, li,\n// fieldset, form, label, legend,\n// table, caption, tbody, tfoot, thead, tr, th, td,\n// article, aside, canvas, details, embed, \n// figure, figcaption, footer, header, hgroup, \n// menu, nav, output, ruby, section, summary,\n// time, mark, audio, video {\n// \tmargin: 0;\n// \tpadding: 0;\n// \tborder: 0;\n// \tfont-size: 100%;\n// \tvertical-align: baseline;\n// }\napplet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend, caption, tbody, tfoot, thead,\naside, canvas, details, embed, \nfigure, figcaption, footer, header, hgroup, \nmenu, nav, output, ruby, summary,\ntime, mark, audio, video {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tvertical-align: baseline;\n}\nh1, h2, h3, h4, h5, h6{\n  text-align: start;\n}\n/* HTML5 display-role reset for older browsers */\n// article, aside, details, figcaption, figure, \n// footer, header, hgroup, menu, nav, section {\n// \tdisplay: block;\n// }\nbody {\n\tline-height: normal;\n}\nol, ul {\n\tlist-style: none;\n}\nblockquote, q {\n\tquotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n\tcontent: '';\n\tcontent: none;\n}\ntable {\n\t// border-collapse: collapse;\n\tborder-spacing: 0;\n}\n:focus-visible{\n\toutline-color: var(--sdk-global-theme-color);\n    outline-offset: 1px;\n    outline-style: auto;\n}\n// *:focus{\n// \toutline-color: var(--sdk-global-theme-color);\n//     outline-offset: 1px;\n//     outline-style: auto;\n// }\n// End\n\nimg{\n\t&:focus{\n\t\toutline-color: var(--sdk-global-theme-color);\n\t\toutline-offset: 1px;\n\t\toutline-style: auto;\n\t\toutline: 1px solid var(--sdk-global-theme-color);\n\t}\n}\nbutton{\n\tcursor: pointer;\n}\n\n/********* Scroll bar global css start *********************/\nbody::-webkit-scrollbar {\n    width: 10px;\n    height: 10px;\n    cursor: pointer;\n  }\n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    cursor: pointer;\n  }\n  ::-webkit-scrollbar-thumb {\n    background-color: var(--sdk-scrollbar-bg);\n    border-radius: 7px;\n    transition: background-color 0.2s linear, width 0.2s ease-in-out;\n    -webkit-transition: background-color 0.2s linear, width 0.2s ease-in-out;\n  }\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n\t  -webkit-appearance: none;\n\t  margin: 0;\n  }\n\n  /* Firefox */\n  input[type=number] {\n\t-moz-appearance: textfield;\n  }\n  /********* Scroll bar global css end *********************/\n}\n\n.display-hide{\n  display: none !important;\n}","@import '../reset.scss';\n@import '../variables.scss';\n@import '../typography.scss';\n@import '../utilities.scss';\n\n.kore-chat-window-main-section {\n  position: fixed;\n  height: calc(100% - 136px);\n  border-radius: 4px;\n  right: 40px;\n  bottom: 96px;\n  top: auto;\n  width: 400px;\n  max-width: calc(100% - 80px);\n  transition: 0.4s all ease;\n  font-family: var(--global-font-family);\n  &.is-wigets-enabled{\n    box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n    width: 444px;\n    .chat-widgetwrapper-main-container{\n      border-radius: 0px 4px 4px 0px;\n      box-shadow: none !important;\n      .chat-widget-header{\n        border-radius: 0px 4px 0px 0px;\n      }\n    }\n  }\n  &.avatar-medium-size{\n    height: calc(100% - 148px);\n    bottom: 108px;\n    .avatar-variations-footer {\n      .avatar-actions {\n        &.variation-4{\n          .avatar-bg{\n            &::before{\n              left: 4px;\n              right: -35px;\n              transform: rotate(0);\n              bottom: 4px;\n            }\n          }\n        }\n        &.variation-2 {\n          .avatar-bg{\n            width: 68px;\n          }\n        }\n        .avatar-bg{\n          width: 60px;\n          height: 60px;\n        }\n      }\n    }\n  }\n  &.avatar-large-size{\n    height: calc(100% - 160px);\n    bottom: 120px;\n    .avatar-variations-footer {\n      .avatar-actions {\n        &.variation-4{\n          .avatar-bg{\n            &::before{\n              left: 12px;\n              right: -37px;\n              transform: rotate(0);\n              bottom: 6px;\n            }\n          }\n        }\n        .avatar-bg{\n          width: 72px;\n          height: 72px;\n        }\n      }\n    }\n  }\n  &.no-avatar-bg-icon{\n    height: calc(100% - 80px);\n  }\n  @media (max-width: $media-mobile) {\n    width: calc(100% - 20px);\n    height: calc(100% - 115px);\n    right: 10px;\n    bottom: 40px;\n    max-width: 100%;\n  }\n  @media (max-height: 300px) {\n    /* Approx. 200% zoom */\n    height: 100%;\n    bottom: 0px;\n  }\n  &.minimize-chat{\n    height: 0px;\n    width: 0px;\n    top: auto;\n    .welcome-chat-section{\n      transform: scale(0);\n    }\n    .kr-wiz-menu-chat {\n      display: none !important;\n      &.show {\n        display: none !important;\n      }\n    }\n  }\n\n  .kr-wiz-menu-chat {\n    display: none;\n\t\tfloat: left;\n\t\ttransition: ease-in .33s;\n    &.show {\n      display: block;\n    }\n\t}\n\n  .kore-sdk-error-section {\n    display: block;\n    text-align: center;\n    background: #FEF3F2;\n    color: #B42318;\n    font-size: var(--font-size-text-xs, 12px);\n    font-weight: var(--font-weight-normal-Medium, 500);\n    line-height: var(--font-line-height-text-xs, 16px);\n    padding: 8px;\n    &.hide {\n      display: none;\n    }\n  }\n}","// Avatar animations\n\n@keyframes remove-hidden {\n    0% {\n      overflow: hidden;\n    }\n    100% { \n        overflow: inherit; \n    }\n}\n\n@keyframes bounce2 {\n    0%, 20%, 50%, 80%, 100% {transform: translateY(0);}\n    40% {transform: translateY(-30px);}\n    60% {transform: translateY(-15px);}\n}\n@keyframes bounce-in-avatar {\n    0% {\n      opacity: 0;\n      transform: scale(.3);\n    }\n    50% {\n      opacity: 1;\n      transform: scale(1);\n    }\n    70% { transform:translateY(20px)}\n    100% { transform: scale(1) translate(0);}\n}\n\n@keyframes avatarBubbleAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(10px); /* Move the elements 100% down */\n    }\n    80% {\n        opacity: 1;\n        transform: translateY(-10px); /* Move the elements to their original position */\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n@keyframes slide-up {\n    0% {\n        opacity: 0;\n        transform: translateY(100%); /* Move the elements 100% down */\n    }\n    100% {\n        opacity: 1;\n        transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n// End Avatar animations\n\n// Chat open animations\n@keyframes quick {\n    0% {\n      opacity: 0;\n      transform: scale(0);\n      overflow: hidden;\n    }\n    90%, 50%{\n      overflow: hidden;\n    }\n    100% { \n        opacity: 1;\n        transform: scale(1);\n        overflow: inherit;\n    }\n}\n@keyframes bounce-in {\n    0% {\n      opacity: 0;\n      overflow: hidden;\n    }\n    40% {\n      opacity: 1;\n      overflow: hidden;\n    }\n    60% { \n      transform:translate(-10px)\n    }\n    80% { \n      transform:translate(-15px)\n    }\n    100% { \n      transform: none;\n      overflow: inherit;\n    }\n}\n\n// End\n\n// Bubble animations\n\n@keyframes bubbleAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    20% {\n      opacity: 0;\n      transform: translateY(10%);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0%);\n    }\n}\n\n// End\n\n// Voice show animation\n\n@keyframes voiceShowAnim {\n  0% {\n    opacity: 0;\n    transform: translateY(100%);\n  }\n  100% {\n    opacity: 1;\n    transform: translate(0%);\n  }\n}\n\n// Left to right template animations\n\n@keyframes left-to-right-slide-anim {\n    0% {\n      opacity: 0;\n      transform: translateX(-100%);\n    }\n    80% {\n        opacity: 0.5;\n        transform: translateX(0px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n}\n\n// End\n\n// Right to Left template animations\n\n@keyframes right-to-left-slide-anim {\n    0% {\n      opacity: 0;\n      transform: translateX(100%); /* Move the elements 100% down */\n    }\n    80% {\n        opacity: 0.5;\n        transform: translateX(10px); /* Move the elements to their original position */\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0); /* Move the elements to their original position */\n    }\n}\n\n// Voice recording animations\n\n@keyframes recording {\n    from {\n        transform: scale( 1.1 );\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 1px rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 5px rgba(#4B4EDE, 0.2);\n    }\n\n    50% {\n        transform: none;\n    }\n\n    to {\n        transform: scale( 1.1 );\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 6px rgba(#4B4EDE, 0),\n          0 0 0 10px rgba(#4B4EDE, 0);\n    }\n}\n\n@keyframes voiceAnim {\n    from {\n        transform: scale( 1.1 );\n    }\n    0% {\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 1px rgba(#4B4EDE, 0.2),\n          0 0 0 3px rgba(#4B4EDE, 0.2),\n          0 0 0 5px rgba(#4B4EDE, 0.2);\n        // transform: scale(1.1);\n      }\n      50% {\n        transform: none;\n    }\n      100% {\n        box-shadow: 0 0 0 0 rgba(#4B4EDE, 0.2),\n          0 0 0 4px rgba(#4B4EDE, 0.2),\n          0 0 0 20px rgba(#4B4EDE, 0),\n          0 0 0 30px rgba(#4B4EDE, 0);\n        // transform: scale(0.9);\n        transform: scale( 1.1 );\n    }\n    to {\n        transform: scale( 1.1 );\n    }\n}\n\n// End\n\n// Bottom slider open close animations\n\n@keyframes closeBottomToTopAnim {\n    0% {\n      transform: translateY(0%);\n    }\n    100% {\n        opacity: 0;\n        transform: translateY(100%);\n        display: none;\n    }\n}   \n@keyframes slideBottomToTopAnim {\n    0% {\n      opacity: 0;\n      transform: translateY(100%);\n    }\n    80% {\n        opacity: 1;\n        transform: translateY(-10px);\n    }\n    100% {\n      opacity: 1;\n      transform: translate(0);\n    }\n}   \n\n// End\n\n\n// Zoom Animations\n\n.zoomIn {\n  -webkit-animation-name: zoomIn;\n  animation-name: zoomIn;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(.3, .3, .3);\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(.3, .3, .3);\n    transform: scale3d(.3, .3, .3);\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n// End\n\n// Slide Animations\n\n.slideInRight {\n  -webkit-animation-name: slideInRight;\n  animation-name: slideInRight;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible;\n  }\n  80% {\n    -webkit-transform: translateX(0);\n    transform: translateX(2px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideInRight {\n  0% {\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    visibility: visible;\n  }\n  80% {\n    -webkit-transform: translateX(0);\n    transform: translateX(2px);\n  }\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n.scale-up-br {\n\t-webkit-animation: scale-up-br 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n\t        animation: scale-up-br 0.4s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;\n}\n\n.scale-out-br {\n\t-webkit-animation: scale-out-br 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n\t        animation: scale-out-br 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;\n}\n\n @-webkit-keyframes scale-out-br {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n@keyframes scale-out-br {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n  100% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n    opacity: 1;\n  }\n}\n\n\n@-webkit-keyframes scale-up-br {\n0% {\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n100% {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  -webkit-transform-origin: 100% 100%;\n          transform-origin: 100% 100%;\n}\n}\n\n@keyframes scale-up-br {\n  0% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    -webkit-transform-origin: 100% 100%;\n            transform-origin: 100% 100%;\n  }\n}\n\n\n/// Loader Animations\n\n@-webkit-keyframes spinLoader {\n  0% { -webkit-transform: rotate(0deg); }\n  100% { -webkit-transform: rotate(360deg); }\n}\n\n@keyframes spinLoader {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n\n// Rotate Icon close\n\n.rotateIn {\n  -webkit-animation-name: rotateIn;\n  animation-name: rotateIn;\n  -webkit-animation-duration: 0.5s;\n  animation-duration: 0.5s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n@keyframes rotateIn {\n  0% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: rotate3d(0, 0, 1, -200deg);\n    transform: rotate3d(0, 0, 1, -200deg);\n    opacity: 0;\n  }\n\n  100% {\n    -webkit-transform-origin: center;\n    transform-origin: center;\n    -webkit-transform: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n\n// Typing Indicator\n  \n@keyframes dot-flashing {\n  0% {\n      background-color: var(--sdk-gloabl-bg-secondary);\n  }\n  50%, 100% {\n      opacity: 0.5;\n  }\n}\n\n// Fade In\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n  animation-name: fadeIn;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  display: flex;\n}\n\n@-webkit-keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n\n\n\n.bounceInUp {\n  -webkit-animation-name: bounceInUp;\n  animation-name: bounceInUp;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes bounceInUp {\n\n  0%,\n  60%,\n  75%,\n  90%,\n  100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes bounceInUp {\n\n  0%,\n  60%,\n  75%,\n  90%,\n  100% {\n    -webkit-transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n    transition-timing-function: cubic-bezier(0.215, 0.610, 0.355, 1.000);\n  }\n\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 3000px, 0);\n    transform: translate3d(0, 3000px, 0);\n  }\n\n  60% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  75% {\n    -webkit-transform: translate3d(0, 10px, 0);\n    transform: translate3d(0, 10px, 0);\n  }\n\n  90% {\n    -webkit-transform: translate3d(0, -5px, 0);\n    transform: translate3d(0, -5px, 0);\n  }\n\n  100% {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n  animation-name: fadeInUp;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n\n  100% {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}\n\n.slideOutDown {\n    -webkit-animation-name: slideOutDown;\n    animation-name: slideOutDown;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n  }\n  @-webkit-keyframes slideOutDown {\n    0% {\n      -webkit-transform: translateY(-10%);\n      transform: translateY(-10%);\n    }\n    100% {\n      -webkit-transform: translateY(0);\n      transform: translateY(0);\n    }\n}","@import \"./animations.scss\";\n\n// Media Breakpoins\n\n$media-tablet: 768px;\n$media-mobile: 600px;\n\n:root{\n\n    // Main 4 colors pallet\n    --sdk-gloabl-primary-color:var(--chat-sdk-branding--global-primary-color);     // #4B4EDE;\n    --sdk-gloabl-secondary-color:var(--chat-sdk-branding--global-secondary-color);    // #EAECF0;\n    --sdk-global-primary-text:var(--chat-sdk-branding--global-primary-text);     // #101828;\n    --sdk-global-secondary-text:var(--chat-sdk-branding--global-secondary-text);      // #FFFFFF;\n    // End\n\n    // Main 4 colors for Panle and Widgets\n        --theme-panel-wigdet-primary-bg-color:var(--sdk-gloabl-primary-color);  // #175cd3;\n        --theme-panel-wigdet-secondary-bg-color:var(--sdk-gloabl-secondary-color);   // #EAECF0;\n        --theme-panel-wigdet-primary-text-color:var(--sdk-global-primary-text);  // #101828;\n        --theme-panel-wigdet-secondary-text-color:var(--sdk-global-secondary-text) ;   // #667085;\n    \n        // Extra colors\n        --panel-wigdet-primary-bg-color:var(--theme-panel-wigdet-primary-bg-color);\n        --panel-wigdet-secondary-bg-color:var(--theme-panel-wigdet-secondary-bg-color);\n        --panel-wigdet-primary-text-color:var(--theme-panel-wigdet-primary-text-color);\n        --panel-wigdet-secondary-text-color:var(--theme-panel-wigdet-secondary-text-color);\n        \n        --panel-wigdet-border-color:var(--panel-wigdet-secondary-bg-color);\n        --panel-wigdet-white-bg-color:var(--chat-sdk-branding--widget_panel-colors-bg_color);           //   #fff;\n        --panel-wigdet-white-text-color:#fff;\n        --panel-wigdet-left-menu-bg:var(--chat-sdk-branding--widget_panel-colors-bg_color);\n        --panel-wigdet-left-menu-selected-bg:var(--chat-sdk-branding--widget_panel-colors-sel_bg_color);\n        --panel-wigdet-left-menu-font-clr:var(--chat-sdk-branding--widget_panel-colors-color);\n        --panel-wigdet-left-menu-selected-font-clr:var(--chat-sdk-branding--widget_panel-colors-sel_color);\n\n    // End\n\n\n    // Font Family\n        --global-font-family: var(--chat-sdk-branding--global-font-family);   // \"Inter\";\n    // End\n\n    --sdk-global-theme-color:var(--sdk-gloabl-primary-color);\n    --sdk-gloabl-bg-secondary:var(--sdk-gloabl-secondary-color);\n    --sdk-global-white:var(--sdk-global-secondary-text);\n    --sdk-global-white-bg:var(--chat-sdk-branding--body-white-background);\n    --sdk-gloabl-text-color:var(--sdk-global-primary-text);\n    --sdk-gloabl-text-desc-color:var(--sdk-global-primary-text);\n    --sdk-gloabl-border-color:var(--sdk-gloabl-secondary-color);\n    --sdk-scrollbar-bg:var(--sdk-gloabl-bg-secondary);\n\n    // Avatar Variables\n        --avatar-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color);  // var(--sdk-global-theme-color); \n        --avatar-send-msg-bg:var(--chat-sdk-branding--chat_bubble-bg-primary_color); // var(--sdk-global-theme-color);\n        --avatar-icon-color:var(--chat-sdk-branding--chat_bubble-bg-secondary_color);\n        --avatar-text-colr:var(--sdk-gloabl-text-color);\n    // End\n\n    //chat Widget Main\n        --chat-widget-box-shadow:0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n    // End\n    \n    // Agent Joined Template\n        --agent-joined-bg:var(--sdk-gloabl-bg-secondary);\n        --agent-joined-border:var(--sdk-gloabl-border-color);\n        --agent-joined-text-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Welcome screen Variables\n        --welcome-bg:var(--sdk-global-white-bg); //#F8FAFC\n        --welcome-shadow:0px 4px 12px 2px rgba(32,33,36,0.12);\n        --welcome-header-bg: var(--chat-sdk-branding--welcome_screen-background-color);  // var(--sdk-global-theme-color);\n        --welcome-header-text-color:var(--chat-sdk-branding--welcome_screen-top_fonts-color);  // var(--sdk-global-white);\n        --welcome-start-conv-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-bot-bg:var(--sdk-global-theme-color);\n        --welcome-start-conv-bot-title:var(--sdk-gloabl-text-color);\n        --welcome-start-conv-bot-desc:var(--sdk-gloabl-text-desc-color);\n        --welcome-start-conv-quick-btn-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-quick-btn-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-quick-btn-text:var(--sdk-gloabl-text-color);\n        --welcome-start-conv-search-bg:var(--sdk-global-white-bg);\n        --welcome-start-conv-search-border:var(--sdk-gloabl-border-color);\n        --welcome-start-conv-button-bg:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_button_color); // var(--sdk-global-theme-color);\n        --welcome-start-conv-button-border:var(--sdk-global-theme-color);\n        --welcome-start-conv-button-color:var(--chat-sdk-branding--welcome_screen-starter_box-start_conv_text_color); //  var(--sdk-global-white);\n        --welcome-footer-bg:var(--chat-sdk-branding--welcome_screen-bottom_background-color);  // var(--sdk-global-theme-color);\n        --welecome-footer-text-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Chat Widget Header Variables;\n        --chat-widget-header-bg:var(--chat-sdk-branding--header-bg-bg_color);  // var(--sdk-global-white-bg);\n        --chat-widget-header-border:var(--sdk-gloabl-border-color);\n        --chat-widget-header-bg-large:linear-gradient(180deg, var(--sdk-global-theme-color) 0%, var(--sdk-global-theme-color) 40.67%, rgba(255, 255, 255, 0) 80.38%); // var(--sdk-global-theme-color)\n        --chat-widget-header-bg-large-info-bg:var(--sdk-global-white-bg);\n        --chat-widget-header-bg-large-actions-color:var(--sdk-global-white);\n        --chat-widget-header-bot-name-color:var(--chat-sdk-branding--header-title-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-header-bot-name-desc:var(--chat-sdk-branding--header-sub_title-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-header-actions-color:var(--chat-sdk-branding--header-icons-color);  // var(--sdk-gloabl-text-color);\n        --chat-widget-header-img-border:var(--sdk-global-white);\n    // End\n\n    // Chat Widget Body Variables;\n        --chat-widget-body-bg:var(--chat-sdk-branding--body-background-bg);  //  var(--sdk-global-white-bg);\n    // End\n\n    // Chat Widget Footer Variables;\n        --chat-widget-footer-bg: var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-bg:var(--chat-sdk-branding--footer-bg-bg_color); // var(--sdk-gloabl-bg-secondary);\n        --chat-widget-compose-bar-border:var(--sdk-gloabl-border-color);\n        --chat-widget-compose-bar-text-area-bg:var(--chat-sdk-branding--footer-compose_bar-bg_color);  // var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-text-area-border:var(--chat-sdk-branding--footer-compose_bar-outline-color); // var(--sdk-gloabl-border-color);\n        --chat-widget-compose-bar-text-area-color:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-text-area-placeholder-color:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-voice-speak-info-text:var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-voice-icon-bg:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-icon-border:var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-voice-icon-color:var(--sdk-global-white);\n        --chat-widget-compose-bar-voice-speak-msg-bg:var(--sdk-global-white-bg);\n        --chat-widget-compose-bar-voice-speak-msg-selected-bg:var(--sdk-gloabl-bg-secondary);\n        --chat-widget-compose-bar-voice-speak-msg-color:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-speak-msg-border:var(--sdk-global-theme-color);\n        --chat-widget-compose-bar-voice-recording-animation-shadow:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 1px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2), 0 0 0 5px rgba(var(--sdk-global-theme-color), 0.2);\n        --chat-widget-compose-bar-voice-recording-animation-shadow-zoom:0 0 0 0 rgba(var(--sdk-global-theme-color), 0.2),0 0 0 3px rgba(var(--sdk-global-theme-color), 0.2),0 0 0 6px rgba(var(--sdk-global-theme-color), 0),0 0 0 10px rgba(var(--sdk-global-theme-color), 0);\n        --chat-widget-compose-bar-menu-icon-color:var(--chat-sdk-branding--footer-menu_icon-color); // var(--sdk-gloabl-text-color);\n        --chat-widget-compose-bar-other-icons:var(--chat-sdk-branding--footer-icons-color); // var(--sdk-gloabl-text-color);\n    // End\n\n    // Bot Bubble Messages Variables\n        --bot-bubble-text-color:var(--sdk-gloabl-text-color);\n        --bot-bubble-msg-bg:var(--chat-sdk-branding--body-bot_message-bg_color);  // var(--sdk-gloabl-bg-secondary);\n        --bot-bubble-msg-bg-hover:var(--chat-sdk-branding--body-bot_message-bg_color);  // var(--sdk-gloabl-bg-secondary);\n        --bot-bubble-msg-color:var(--chat-sdk-branding--body-bot_message-color);  // var(--sdk-gloabl-text-color);\n        --bot-bubble-img-border:var(--sdk-global-white-bg);\n    //End   \n\n    // Name\n        --name-color:var(--chat-sdk-branding--body-agent_message-title_color); // var(--sdk-global-primary-text)\n    // End\n\n    // Time stamp\n        --time-stamp-color:var(--chat-sdk-branding--body-time_stamp-color);     // var(--sdk-global-primary-text)\n    //End\n\n    // Agent Bubble Messages Variables\n        --agent-bubble-text-color:var(--sdk-gloabl-text-color);\n        --agent-bubble-msg-bg:var(--chat-sdk-branding--body-user_message-bg_color);  // var(--sdk-global-theme-color);\n        --agent-bubble-msg-bg-hover:var(--chat-sdk-branding--body-user_message-bg_color);  // var(--sdk-global-theme-color);\n        --agent-bubble-msg-color:var(--chat-sdk-branding--body-user_message-color);  // var(--sdk-global-white);\n        --agent-bubble-img-border:var(--sdk-global-white-bg);\n        --agent-bubble-read-status-icon-color:#22C55E;\n    //End\n\n    // Date Seperator styles\n        --date-seperator-bg:var(--sdk-gloabl-bg-secondary);\n        --date-seperator-border:var(--sdk-gloabl-border-color);\n        --date-seperator-line-border:var(--sdk-gloabl-border-color);\n        --date-seperator-color:var(--sdk-gloabl-text-color);\n    // End\n\n    // Buttons\n        --button-bg-color: var(--chat-sdk-branding--body-buttons-bg_color);\n        --button-text-color: var(--chat-sdk-branding--body-buttons-color);\n    // End\n\n    // Template Styles\n\n        // Button Template\n        --button-temp-bg:var(--sdk-global-white-bg);\n        --button-temp-border:var(--sdk-gloabl-border-color);\n        --button-temp-color:var(--sdk-gloabl-text-color);\n        --button-temp-bg-hover:var(--sdk-gloabl-bg-secondary);\n        --button-temp-bg-variation-1:var(--sdk-gloabl-bg-secondary);\n        --button-temp-variation-1-border:transparent;\n        --button-temp-variation-1-color:var(--button-bg-color);   // --sdk-global-theme-color\n        --button-temp-bg-variation-1-hover:linear-gradient(0deg, rgba(75, 78, 222, 0.07) 0%, rgba(75, 78, 222, 0.07) 100%), var(--sdk-gloabl-bg-secondary);\n        --button-temp-bg-variation-2:var(--button-bg-color);   // --sdk-global-theme-color\n        --button-temp-variation-2-border:var(--button-bg-color);  // --sdk-global-theme-color\n        --button-temp-variation-2-color:var(--button-text-color);  // --sdk-global-white\n        --button-temp-bg-variation-2-hover:linear-gradient(0deg, rgba(0, 0, 0, 0.20) 0%, rgba(0, 0, 0, 0.20) 100%), var(--button-bg-color);  // --sdk-global-theme-color\n        // End\n\n        // Card Template\n        --card-main-wrapper-bg:var(--sdk-gloabl-bg-secondary);\n        --card-main-wrapper-border:var(--sdk-gloabl-border-color);\n        --card-heading-title:var(--sdk-gloabl-text-color);\n        --card-temp-border:var(--sdk-gloabl-border-color);\n        --card-temp-bg:var(--sdk-global-white-bg);\n        --card-temp-color:var(--sdk-gloabl-text-color);\n        --card-temp-h1-color:var(--sdk-gloabl-text-color);\n        --card-temp-p-color:var(--sdk-gloabl-text-color);   \n        --card-temp-view-more-bg:var(--sdk-global-white-bg);\n        --card-temp-view-more-color:var(--sdk-global-theme-color);\n        --card-temp-view-more-border:var(--sdk-global-theme-color);\n        --card-temp-border-divided-bg:var(--sdk-gloabl-border-color);\n        // End     \n\n        // Form Template\n        --form-temp-bg:var(--sdk-gloabl-bg-secondary);\n        --form-temp--text-color:var(--sdk-gloabl-text-color);\n        --form-temp-input-bg:var(--sdk-global-white-bg);\n        --form-temp-input-box-shadow:0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n        --form-temp-input-placeholder:var(--sdk-gloabl-text-color);\n        \n        // Table Template\n        --table-border:var(--sdk-gloabl-border-color);\n        --table-header-text-color:var(--sdk-gloabl-text-color);\n        --table-body-tr-bg:var(--sdk-gloabl-bg-secondary);\n        --table-desc-text-color:var(--sdk-gloabl-text-color);\n        // End\n\n        // Radio Template\n            --radio-desc-text-clr:var(--sdk-gloabl-text-color);\n            --radio-border:var(--sdk-gloabl-border-color);\n            --radio-bg:var(--sdk-global-white-bg);\n            --radio-checked-shadow:inset 0 0 0 6px var(--sdk-global-white-bg);\n        // End\n}   \n\n\n\n// STANDARD SIZES\n$font-s-5:0.3125rem;\n$font-s-6:0.375rem;\n$font-s-7:0.4375rem;\n$font-s-8:0.5rem;\n$font-s-9:0.5625rem;\n$font-s-10:0.625rem;\n$font-s-11:0.6875rem;\n$font-s-12:0.75rem;\n$font-s-13:0.8125rem;\n$font-s-14:0.875rem;\n$font-s-15:0.9375rem;\n$font-s-16:1rem;\n$font-s-17:1.0625rem;\n$font-s-18:1.125rem;\n$font-s-19:1.1875rem;\n$font-s-20:1.25rem;\n$font-s-21:1.3125rem;\n$font-s-22:1.375rem;\n$font-s-23:1.4375rem;\n$font-s-24:1.5rem;\n$font-s-25:1.5625rem;\n$font-s-26:1.625rem;\n$font-s-27:1.6875rem;\n$font-s-28:1.75rem;\n$font-s-29:1.8125rem;\n$font-s-30:1.875rem;\n$font-s-31:1.9375rem;\n$font-s-32:2rem;\n$font-s-33:2.0625rem;\n$font-s-40:2.5rem;\n\n// Button primary\n\n.kr-button-primary{\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    width: 100%;\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    background: var(--button-temp-bg-variation-2);\n    border: 1px solid var(--button-temp-variation-2-border);\n    color: var(--button-temp-variation-2-color);\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-temp-bg-variation-2-hover);\n    }\n    &:disabled{\n        opacity: 0.5;\n        pointer-events: none;\n    }\n}\n.kr-button-secondary{\n    width: 100%;\n    background: var(--button-temp-bg);\n    border: 1px solid var(--button-temp-border);\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    color: var(--button-temp-color);\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-temp-bg-hover);\n    }\n}\n\n.kr-button-blue-light{\n    width: 100%;\n    background: var(--button-bg-color);\n    border: 1px solid var(--button-bg-color);\n    border-radius: 4px;\n    padding: 5px 16px;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 18px;\n    height: 30px;\n    color: var(--button-text-color);   // #2B75E4\n    cursor: pointer;\n    text-align: center;\n    transition: 0.2s all ease;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 5px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    max-width: 100%;\n    svg{\n        path{\n            fill: var(--button-bg-color);  // #2B75E4\n        }\n    }\n    &.lg{\n        padding: 10px 16px;\n        height: 40px;\n        font-size: 14px;\n    }\n    &:hover{\n        background: var(--button-bg-color);\n    }\n}\n\n.kore-chat-window-main-section{\n    .chart-disp-val{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n    .chart-axis-line{\n        stroke: var(--sdk-gloabl-text-color);\n    }\n    .legend-title{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n    polyline{\n        stroke: var(--sdk-gloabl-text-color);\n    }\n    .mouse-per-line{\n        text{\n            fill: var(--sdk-gloabl-text-color);\n            font-size: 12px;\n        }\n    }\n    .legend-value{\n        fill: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n    }\n}","// Typography: text scale only. Color uses `--sdk-gloabl-text-color` from\n// `src/templatemanager/base/variables.scss`. Classes use `$kr-prefix` (default `kwsdk-`)\n\n@use 'sass:map';\n\n$kr-prefix: 'kwsdk-' !default;\n\n@mixin headingTextDisplay(\n\t$size,\n\t$weight: var(--font-weight-normal-Regular, 400),\n\t$lineheight: normal,\n\t$color: var(--sdk-gloabl-text-color, #101828),\n\t$textalign: start,\n\t$spacing: null\n) {\n\tfont-size: $size;\n\tfont-weight: $weight;\n\tline-height: $lineheight;\n\tcolor: $color;\n\ttext-align: $textalign;\n\tmargin: 0;\n\t@if $spacing {\n\t\tletter-spacing: $spacing;\n\t}\n\n\t&.medium {\n\t\tfont-weight: 500;\n\t}\n\t&.semibold {\n\t\tfont-weight: 600;\n\t}\n\t&.bold {\n\t\tfont-weight: 700;\n\t}\n}\n\n// Single `text` group: display sizes + body scale (unique keys; body xl–xxxs matches former `text` map).\n$typography-variants: (\n\t'text': (\n\t\t'xl': (\n\t\t\tsize: 20px,\n\t\t\tline-height: 30px,\n\t\t),\n\t\t'lg': (\n\t\t\tsize: 18px,\n\t\t\tline-height: 28px,\n\t\t),\n\t\t'md': (\n\t\t\tsize: 16px,\n\t\t\tline-height: 24px,\n\t\t),\n\t\t'sm': (\n\t\t\tsize: 14px,\n\t\t\tline-height: 20px,\n\t\t),\n\t\t'xs': (\n\t\t\tsize: 12px,\n\t\t\tline-height: 16px,\n\t\t),\n\t\t'xxs': (\n\t\t\tsize: 10px,\n\t\t\tline-height: 12px,\n\t\t),\n\t\t'xxxs': (\n\t\t\tsize: 8px,\n\t\t\tline-height: 12px,\n\t\t),\n\t),\n) !default;\n\n$text-color: var(--sdk-gloabl-text-color);\n\n@each $size-name, $properties in map.get($typography-variants, 'text') {\n\t.#{$kr-prefix}text-#{$size-name} {\n\t\t$spacing-value: map.get($properties, spacing);\n\n\t\t@include headingTextDisplay(\n\t\t\t$size: map.get($properties, size),\n\t\t\t$lineheight: map.get($properties, line-height),\n\t\t\t$color: $text-color,\n\t\t\t$textalign: start,\n\t\t\t$spacing: $spacing-value\n\t\t);\n\t}\n}\n","// Kore Web SDK utility classes\n// All classes use the `kwsdk-` prefix\n\n$kr-prefix: 'kwsdk-' !default;\n// One step = 4px at 16px root; tokens 1–6 → 4, 8, 12, 16, 20, 24px.\n$kr-spacer: 0.25rem !default;\n$kr-spacers: (\n\t0: 0,\n\t1: $kr-spacer * 1,\n\t2: $kr-spacer * 2,\n\t3: $kr-spacer * 3,\n\t4: $kr-spacer * 4,\n\t5: $kr-spacer * 5,\n\t6: $kr-spacer * 6,\n\tauto: auto,\n) !default;\n\n// ---- Display ----\n$kr-displays: (\n\tnone: none,\n\tinline: inline,\n\t'inline-block': inline-block,\n\tblock: block,\n\tflex: flex,\n\t'inline-flex': inline-flex,\n\tgrid: grid,\n\t'inline-grid': inline-grid,\n\ttable: table,\n\t'table-row': table-row,\n\t'table-cell': table-cell,\n) !default;\n\n@each $key, $val in $kr-displays {\n\t.#{$kr-prefix}d-#{$key} {\n\t\tdisplay: $val !important;\n\t}\n}\n\n// ---- Flex ----\n$kr-flex-directions: (\n\trow: row,\n\tcolumn: column,\n\t'row-reverse': row-reverse,\n\t'column-reverse': column-reverse,\n) !default;\n\n@each $key, $val in $kr-flex-directions {\n\t.#{$kr-prefix}flex-#{$key} {\n\t\tflex-direction: $val;\n\t}\n}\n\n$kr-justify: (\n\tstart: flex-start,\n\tend: flex-end,\n\tcenter: center,\n\tbetween: space-between,\n\taround: space-around,\n\tevenly: space-evenly,\n) !default;\n\n@each $key, $val in $kr-justify {\n\t.#{$kr-prefix}justify-content-#{$key} {\n\t\tjustify-content: $val;\n\t}\n}\n\n$kr-align-items: (\n\tstart: flex-start,\n\tend: flex-end,\n\tcenter: center,\n\tbaseline: baseline,\n\tstretch: stretch,\n) !default;\n\n@each $key, $val in $kr-align-items {\n\t.#{$kr-prefix}align-items-#{$key} {\n\t\talign-items: $val;\n\t}\n}\n\n$kr-align-content: (\n\tstart: flex-start,\n\tend: flex-end,\n\tcenter: center,\n\tbetween: space-between,\n\taround: space-around,\n\tstretch: stretch,\n) !default;\n\n@each $key, $val in $kr-align-content {\n\t.#{$kr-prefix}align-content-#{$key} {\n\t\talign-content: $val;\n\t}\n}\n\n$kr-align-self: (\n\tauto: auto,\n\tstart: flex-start,\n\tend: flex-end,\n\tcenter: center,\n\tbaseline: baseline,\n\tstretch: stretch,\n) !default;\n\n@each $key, $val in $kr-align-self {\n\t.#{$kr-prefix}align-self-#{$key} {\n\t\talign-self: $val;\n\t}\n}\n\n$kr-flex-wrap: (\n\twrap: wrap,\n\tnowrap: nowrap,\n\t'wrap-reverse': wrap-reverse,\n) !default;\n\n@each $key, $val in $kr-flex-wrap {\n\t.#{$kr-prefix}flex-#{$key} {\n\t\tflex-wrap: $val;\n\t}\n}\n\n.#{$kr-prefix}flex-fill {\n\tflex: 1 1 auto;\n}\n.#{$kr-prefix}flex-grow-0 {\n\tflex-grow: 0;\n}\n.#{$kr-prefix}flex-grow-1 {\n\tflex-grow: 1;\n}\n.#{$kr-prefix}flex-shrink-0 {\n\tflex-shrink: 0;\n}\n.#{$kr-prefix}flex-shrink-1 {\n\tflex-shrink: 1;\n}\n\n@for $i from 0 through 5 {\n\t.#{$kr-prefix}order-#{$i} {\n\t\torder: $i;\n\t}\n}\n.#{$kr-prefix}order-first {\n\torder: -1;\n}\n.#{$kr-prefix}order-last {\n\torder: 6;\n}\n\n@each $size, $value in $kr-spacers {\n\t@if $size != auto {\n\t\t.#{$kr-prefix}gap-#{$size} {\n\t\t\tgap: $value;\n\t\t}\n\t\t.#{$kr-prefix}row-gap-#{$size} {\n\t\t\trow-gap: $value;\n\t\t}\n\t\t.#{$kr-prefix}column-gap-#{$size} {\n\t\t\tcolumn-gap: $value;\n\t\t}\n\t}\n}\n\n// ---- Spacing (margin & padding) ----\n@mixin kr-spacing-utils($prop-short, $properties, $allow-auto: false) {\n\t@each $size, $value in $kr-spacers {\n\t\t@if $allow-auto or $size != auto {\n\t\t\t.#{$kr-prefix}#{$prop-short}-#{$size} {\n\t\t\t\t@each $p in $properties {\n\t\t\t\t\t#{$p}: $value !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n@include kr-spacing-utils('m', (margin), true);\n@include kr-spacing-utils('mt', (margin-top), true);\n@include kr-spacing-utils('mb', (margin-bottom), true);\n@include kr-spacing-utils('ms', (margin-inline-start), true);\n@include kr-spacing-utils('me', (margin-inline-end), true);\n@include kr-spacing-utils('p', (padding), false);\n@include kr-spacing-utils('pt', (padding-top), false);\n@include kr-spacing-utils('pb', (padding-bottom), false);\n@include kr-spacing-utils('ps', (padding-inline-start), false);\n@include kr-spacing-utils('pe', (padding-inline-end), false);\n\n@each $size, $value in $kr-spacers {\n\t@if $size != auto {\n\t\t.#{$kr-prefix}px-#{$size} {\n\t\t\tpadding-inline-start: $value !important;\n\t\t\tpadding-inline-end: $value !important;\n\t\t}\n\t\t.#{$kr-prefix}py-#{$size} {\n\t\t\tpadding-top: $value !important;\n\t\t\tpadding-bottom: $value !important;\n\t\t}\n\t}\n\t.#{$kr-prefix}mx-#{$size} {\n\t\tmargin-inline-start: $value !important;\n\t\tmargin-inline-end: $value !important;\n\t}\n\t.#{$kr-prefix}my-#{$size} {\n\t\tmargin-top: $value !important;\n\t\tmargin-bottom: $value !important;\n\t}\n}\n\n// ---- Text ----\n.#{$kr-prefix}text-start {\n\ttext-align: start !important;\n}\n.#{$kr-prefix}text-end {\n\ttext-align: end !important;\n}\n.#{$kr-prefix}text-center {\n\ttext-align: center !important;\n}\n\n.#{$kr-prefix}text-lowercase {\n\ttext-transform: lowercase !important;\n}\n.#{$kr-prefix}text-uppercase {\n\ttext-transform: uppercase !important;\n}\n.#{$kr-prefix}text-capitalize {\n\ttext-transform: capitalize !important;\n}\n\n.#{$kr-prefix}fw-bold {\n\tfont-weight: 700 !important;\n}\n.#{$kr-prefix}fw-semibold {\n\tfont-weight: 600 !important;\n}\n.#{$kr-prefix}fw-normal {\n\tfont-weight: 400 !important;\n}\n.#{$kr-prefix}fw-medium {\n\tfont-weight: 500 !important;\n}\n.#{$kr-prefix}fw-light {\n\tfont-weight: 300 !important;\n}\n\n.#{$kr-prefix}fst-italic {\n\tfont-style: italic !important;\n}\n.#{$kr-prefix}fst-normal {\n\tfont-style: normal !important;\n}\n\n.#{$kr-prefix}text-wrap {\n\twhite-space: normal !important;\n}\n.#{$kr-prefix}text-nowrap {\n\twhite-space: nowrap !important;\n}\n.#{$kr-prefix}text-truncate {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap !important;\n}\n\n@for $i from 1 through 5 {\n\t.#{$kr-prefix}line-clamp-#{$i} {\n\t\tdisplay: -webkit-box;\n\t\t-webkit-box-orient: vertical;\n\t\tline-clamp: $i;\n\t\t-webkit-line-clamp: $i;\n\t\toverflow: hidden;\n\t}\n}\n\n.#{$kr-prefix}text-decoration-none {\n\ttext-decoration: none !important;\n}\n.#{$kr-prefix}text-decoration-underline {\n\ttext-decoration: underline !important;\n}\n.#{$kr-prefix}text-decoration-line-through {\n\ttext-decoration: line-through !important;\n}\n\n// ---- Overflow ----\n$kr-overflows: auto, hidden, visible, scroll;\n@each $o in $kr-overflows {\n\t.#{$kr-prefix}overflow-#{$o} {\n\t\toverflow: $o !important;\n\t}\n\t.#{$kr-prefix}overflow-x-#{$o} {\n\t\toverflow-x: $o !important;\n\t}\n\t.#{$kr-prefix}overflow-y-#{$o} {\n\t\toverflow-y: $o !important;\n\t}\n}\n\n// ---- Position & inset ----\n.#{$kr-prefix}position-static {\n\tposition: static !important;\n}\n.#{$kr-prefix}position-relative {\n\tposition: relative !important;\n}\n.#{$kr-prefix}position-absolute {\n\tposition: absolute !important;\n}\n.#{$kr-prefix}position-fixed {\n\tposition: fixed !important;\n}\n.#{$kr-prefix}position-sticky {\n\tposition: sticky !important;\n}\n\n$kr-positions: top, bottom, start, end;\n@each $edge in $kr-positions {\n\t$prop: $edge;\n\t@if $edge == start {\n\t\t$prop: inset-inline-start;\n\t} @else if $edge == end {\n\t\t$prop: inset-inline-end;\n\t}\n\t@each $key, $val in (\n\t\t0: 0,\n\t\t50: 50%,\n\t\t100: 100%,\n\t\tauto: auto,\n\t) {\n\t\t@if $edge == start or $edge == end {\n\t\t\t.#{$kr-prefix}#{$edge}-#{$key} {\n\t\t\t\t#{$prop}: $val !important;\n\t\t\t}\n\t\t} @else {\n\t\t\t.#{$kr-prefix}#{$edge}-#{$key} {\n\t\t\t\t#{$edge}: $val !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n// ---- Sizing ----\n@each $key, $val in (\n\t25: 25%,\n\t50: 50%,\n\t75: 75%,\n\t100: 100%,\n\tauto: auto,\n) {\n\t.#{$kr-prefix}w-#{$key} {\n\t\twidth: $val !important;\n\t}\n\t.#{$kr-prefix}h-#{$key} {\n\t\theight: $val !important;\n\t}\n}\n\n.#{$kr-prefix}mw-100 {\n\tmax-width: 100% !important;\n}\n.#{$kr-prefix}mh-100 {\n\tmax-height: 100% !important;\n}\n\n@each $size, $value in (\n\t20: 20px,\n\t40: 40px,\n) {\n\t.#{$kr-prefix}size-#{$size} {\n\t\twidth: $value !important;\n\t\theight: $value !important;\n\t}\n}\n\n\n\n\n\n// ---- Border ----\n.#{$kr-prefix}border {\n\tborder: 1px solid var(--sdk-gloabl-border-color) !important;\n}\n.#{$kr-prefix}border-0 {\n\tborder: 0 !important;\n}\n.#{$kr-prefix}border-top {\n\tborder-top: 1px solid var(--sdk-gloabl-border-color) !important;\n}\n.#{$kr-prefix}border-bottom {\n\tborder-bottom: 1px solid var(--sdk-gloabl-border-color) !important;\n}\n\n.#{$kr-prefix}rounded {\n\tborder-radius: 0.375rem !important;\n}\n.#{$kr-prefix}rounded-0 {\n\tborder-radius: 0 !important;\n}\n.#{$kr-prefix}rounded-1 {\n\tborder-radius: 0.25rem !important;\n}\n.#{$kr-prefix}rounded-2 {\n\tborder-radius: 0.375rem !important;\n}\n.#{$kr-prefix}rounded-3 {\n\tborder-radius: 0.5rem !important;\n}\n.#{$kr-prefix}rounded-4 {\n\tborder-radius: 0.75rem !important;\n}\n.#{$kr-prefix}rounded-circle {\n\tborder-radius: 50% !important;\n}\n.#{$kr-prefix}rounded-pill {\n\tborder-radius: 50rem !important;\n}\n\n// ---- Shadow ----\n.#{$kr-prefix}shadow-none {\n\tbox-shadow: none !important;\n}\n.#{$kr-prefix}shadow-sm {\n\tbox-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\n}\n.#{$kr-prefix}shadow {\n\tbox-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;\n}\n.#{$kr-prefix}shadow-lg {\n\tbox-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;\n}\n\n// ---- Visibility ----\n.#{$kr-prefix}visible {\n\tvisibility: visible !important;\n}\n.#{$kr-prefix}invisible {\n\tvisibility: hidden !important;\n}\n\n// ---- Z-index ----\n@each $z in (0, 1, 2, 3, 4, 5, 10, 50, 100, 1000, 1020, 1030, 1040, 1050) {\n\t.#{$kr-prefix}z-#{$z} {\n\t\tz-index: $z !important;\n\t}\n}\n\n// ---- Pointer / user select ----\n.#{$kr-prefix}user-select-all {\n\tuser-select: all !important;\n}\n.#{$kr-prefix}user-select-auto {\n\tuser-select: auto !important;\n}\n.#{$kr-prefix}user-select-none {\n\tuser-select: none !important;\n}\n\n.#{$kr-prefix}pe-none {\n\tpointer-events: none !important;\n}\n.#{$kr-prefix}pe-auto {\n\tpointer-events: auto !important;\n}\n\n\n.#{$kr-prefix}btn-link{\n\tbackground: none;\n\tborder: none;\n\tcursor: pointer;\n\tcolor: var(--sdk-global-theme-color);\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.#{$kr-prefix}bg-white{\n\tbackground-color: var(--sdk-global-white-bg);\n}\n\n.#{$kr-prefix}bg-transparent{\n\tbackground-color: transparent;\n}\n\n.#{$kr-prefix}bg-secondary {\n\tbackground-color: var(--sdk-gloabl-bg-secondary) !important;\n}\n\n.#{$kr-prefix}text-primary {\n\tcolor: var(--sdk-global-primary-text) !important;\n}\n\n.#{$kr-prefix}text-secondary {\n\tcolor: var(--sdk-global-secondary-text) !important;\n}\n\n.#{$kr-prefix}bg-button {\n\tbackground-color: var(--button-bg-color) !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
